import d from "dayjs";
import re from "dayjs/plugin/utc.js";
import se from "dayjs/plugin/timezone.js";
import xe from "dayjs/plugin/advancedFormat.js";
var gt = /* @__PURE__ */ ((e) => (e.Yes = "yes", e.No = "no", e.PreferNotToSay = "prefer not to say", e))(gt || {}), pt = /* @__PURE__ */ ((e) => (e.Yes = "yes", e.No = "no", e.Open = "open", e.Undecided = "undecided", e.PreferNotToSay = "prefer not to say", e))(pt || {}), yt = /* @__PURE__ */ ((e) => (e.No = "No", e.TryinToQuit = "TryinToQuit", e.SocialSmoker = "SocialSmoker", e.Yes = "Yes", e))(yt || {}), bt = /* @__PURE__ */ ((e) => (e.Never = "Never", e.Sober = "Sober", e.Occasionally = "Occasionally", e.Weekly = "Weekly", e.MostNights = "MostNights", e))(bt || {}), Et = /* @__PURE__ */ ((e) => (e.Yes = "Yes", e.Occasionally = "Occasionally", e.Never = "Never", e))(Et || {}), Tt = /* @__PURE__ */ ((e) => (e.Yes = "Yes", e.Occasionally = "Occasionally", e.Never = "Never", e))(Tt || {}), kt = /* @__PURE__ */ ((e) => (e.Groupme = "Groupme", e.Email = "Email", e.Phone = "Phone", e.Instagram = "Instagram", e))(kt || {}), vt = /* @__PURE__ */ ((e) => (e.administrative_area_level_1 = "administrative_area_level_1", e.administrative_area_level_2 = "administrative_area_level_2", e.administrative_area_level_3 = "administrative_area_level_3", e.administrative_area_level_4 = "administrative_area_level_4", e.administrative_area_level_5 = "administrative_area_level_5", e.archipelago = "archipelago", e.colloquial_area = "colloquial_area", e.continent = "continent", e.country = "country", e.establishment = "establishment", e.finance = "finance", e.floor = "floor", e.food = "food", e.general_contractor = "general_contractor", e.geocode = "geocode", e.health = "health", e.intersection = "intersection", e.landmark = "landmark", e.locality = "locality", e.natural_feature = "natural_feature", e.neighborhood = "neighborhood", e.place_of_worship = "place_of_worship", e.plus_code = "plus_code", e.point_of_interest = "point_of_interest", e.political = "political", e.post_box = "post_box", e.postal_code = "postal_code", e.postal_code_prefix = "postal_code_prefix", e.postal_code_suffix = "postal_code_suffix", e.postal_town = "postal_town", e.premise = "premise", e.room = "room", e.route = "route", e.street_address = "street_address", e.street_number = "street_number", e.sublocality = "sublocality", e.sublocality_level_1 = "sublocality_level_1", e.sublocality_level_2 = "sublocality_level_2", e.sublocality_level_3 = "sublocality_level_3", e.sublocality_level_4 = "sublocality_level_4", e.sublocality_level_5 = "sublocality_level_5", e.subpremise = "subpremise", e.town_square = "town_square", e))(vt || {});
function ge(e, t) {
  return typeof t == "object" && t !== null && t.dataType === "Map" ? new Map(t.value) : t;
}
function It(e, t) {
  return t instanceof Map ? {
    dataType: "Map",
    value: Array.from(t.entries())
    // or with spread: value: [...value]
  } : t;
}
const qr = (e, t) => {
  const n = JSON.parse(e, ge), r = JSON.parse(t, ge);
  for (const [s, o] of r || /* @__PURE__ */ new Map())
    if (!n.has(s))
      n.set(s, o);
    else {
      const a = n.get(s);
      o.completed && (a.completed = !0);
      for (const [i, u] of o.sections || /* @__PURE__ */ new Map())
        if (a.sections || (a.sections = /* @__PURE__ */ new Map()), !a.sections.has(i))
          a.sections.set(i, u);
        else {
          const c = (
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.sections.get(i)
          );
          u.completed && (c.completed = !0), c.videoStats = u.videoStats, u.private ? c.private = !0 : delete c.private;
          for (const [l, _] of u.questions || /* @__PURE__ */ new Map())
            c.questions || (c.questions = /* @__PURE__ */ new Map()), c.questions.set(l, _);
          a.sections.set(i, c);
        }
      n.set(s, a);
    }
  return JSON.stringify(n, It);
};
var v = /* @__PURE__ */ ((e) => (e.LifePartner = "LifePartner", e.LongTerm = "LongTerm", e.LongTermOpenToShortTerm = "LongTermOpenToShortTerm", e.ShortTerm = "ShortTerm", e.ShortTermOpenToLongTerm = "ShortTermOpenToLongTerm", e.FiguringOutDatingGoals = "FiguringOutDatingGoals", e))(v || {}), y = /* @__PURE__ */ ((e) => (e.Core = "Core", e.ShortTerm = "ShortTerm", e.Next = "Next", e))(y || {});
const Yr = ["spark-intro"], Kr = [
  "Agender",
  "Androgyne",
  "Androgynous",
  "Bigender",
  "Female to male",
  "FTM",
  "Intersex",
  "Male to female",
  "Man",
  "MTF",
  "Neither",
  "Neutrois",
  "Non-binary",
  "Other",
  "Pangender",
  "Queer",
  "Trans",
  "Trans man",
  "Trans person",
  "Trans woman",
  "Transgender",
  "Transgender female",
  "Transgender male",
  "Transgender man",
  "Transgender person",
  "Transgender woman",
  "Transfeminine",
  "Transmasculine",
  "Two spirit",
  "Vakasalewalewa",
  "Woman"
], Hr = [
  "Agnostic",
  "Atheist",
  "Buddhist",
  "Catholic",
  "Christian",
  "Hindu",
  "Jewish",
  "Muslim",
  "Spiritual",
  "Prefer not to say"
];
var St = /* @__PURE__ */ ((e) => (e.Password = "Password", e.ThirdParty = "ThirdParty", e.SessionToken = "SessionToken", e.PriveledgedToken = "PrivilegedToken", e.ReadableToken = "ReadableToken", e))(St || {});
const Nt = {
  Body: "ProfilePictureBody",
  Headshot: "ProfilePictureHeadshot",
  Action: "ProfilePictureAction",
  Friends: "ProfilePictureFriends",
  Travel: "ProfilePictureTravel",
  Pet: "ProfilePicturePet"
}, Br = {
  ...Nt
};
var R = /* @__PURE__ */ ((e) => (e.Draft = "Draft", e.Tentative = "Tentative", e.PreRegister = "PreRegister", e.Active = "Active", e))(R || {}), Y = /* @__PURE__ */ ((e) => (e.Dating = "dating", e.Social = "social", e))(Y || {}), b = /* @__PURE__ */ ((e) => (e.Straight = "straight", e.LgbtqMen = "lgbtq_men", e.LgbtqWomen = "lgbtq_women", e.LgbtqAll = "lgbtq_all", e.Anyone = "anyone", e))(b || {}), K = /* @__PURE__ */ ((e) => (e.Draft = "draft", e.Submitted = "submitted", e.Approved = "approved", e.Declined = "declined", e))(K || {}), At = /* @__PURE__ */ ((e) => (e.Spark = "Spark", e.MutualSpark = "MutualSpark", e.NoSpark = "NoSpark", e))(At || {}), Mt = /* @__PURE__ */ ((e) => (e.OppositeGender = "opposite gender", e.MenDatingMen = "men dating men", e.WomenDatingWomen = "women dating women", e.NonBinary = "non binary", e))(Mt || {});
const Le = [
  "title",
  "cms_activity_id",
  "event_kind",
  "audience",
  "gender_balanced",
  "capacity",
  "price",
  "min_age",
  "max_age",
  "age_range_label",
  "overview_preview",
  "overview_read_more",
  "whats_included",
  "wants_hosts",
  "requested_host_count"
], jr = (e) => e.organization_id === null, wt = [
  ...Le,
  "name",
  "start_time",
  "end_time",
  "discount",
  "coupons"
], Wr = [
  ...wt,
  "shared_with_partners"
], zr = "/attending", Xr = (e) => e === "yes" || e === "no", Rt = "/host/check-in", Dt = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, Ot = (e) => Dt.test(e), pe = Ot, Zr = (e) => {
  const t = e.trim();
  if (pe(t))
    return t.toLowerCase();
  try {
    const n = new URL(t), r = `${Rt}/`;
    if (!n.pathname.startsWith(r))
      return null;
    const s = n.pathname.slice(r.length);
    return pe(s) ? s.toLowerCase() : null;
  } catch {
    return null;
  }
}, Qr = [1, 3, 6, 12], xt = ["invite", "eventbrite"], Jr = (e) => xt.includes(e), Lt = ["admin", "owner", "member"], es = {
  admin: "Partner admin",
  owner: "Owner",
  member: "Member"
}, ts = (e) => Lt.includes(e), ns = (e, t) => ({
  groupNumber: e.groupNumber,
  members: t(e.members),
  rotations: e.rotations.map((n) => ({
    rotationNumber: n.rotationNumber,
    subGroups: n.subGroups.map((r) => ({
      label: r.label,
      members: t(r.members)
    }))
  }))
}), rs = 20, ss = {
  numGroups: 1,
  numRotations: 5,
  numGroupsPerRotation: 5,
  oneWayWeight: 1,
  mutualWeight: 2
}, os = "GROUPS_CHANGED", as = "preferred-venue-partner";
var Pt = /* @__PURE__ */ ((e) => (e.Admin = "admin", e.SuperAdmin = "superadmin", e.Host = "host", e))(Pt || {});
const $t = [
  "host"
  /* Host */
], is = (e) => $t.includes(e), cs = (e, ...t) => !!(e != null && e.groups.some((n) => t.includes(n.group))), ls = (e, t) => t && e === "forfeit" ? "refund" : e, us = (e) => [e.first_name, e.last_name].filter(Boolean).join(" ") || e.email || `User ${e.id}`;
var Pe = /* @__PURE__ */ ((e) => (e.Visa = "Visa", e.MasterCard = "MasterCard", e.AmericanExpress = "AmericanExpress", e.Discover = "Discover", e))(Pe || {});
const ds = (e) => Object.values(Pe).includes(e) ? e : null, Ct = {
  AuthorizeNet: "authorizenet",
  Stripe: "stripe"
}, _s = {
  /** The bank said no. Another card may work. */
  CardDeclined: "card_declined",
  /** Number / expiry / CVC / postal code failed validation at the provider. */
  CardInvalid: "card_invalid",
  /** The provider says the card is expired. */
  CardExpired: "card_expired",
  /** Fraud, AVS, or CVV hold — the provider refused rather than the bank. */
  Blocked: "blocked",
  /** The referenced record no longer exists at the provider (ANET E00040). */
  NotFound: "not_found",
  /** The provider already has this record (ANET E00039). */
  Duplicate: "duplicate",
  /**
   * The charge was already refunded in full, so there is nothing left to
   * return. Callers reversing a charge can treat the money as already back.
   */
  AlreadyRefunded: "already_refunded",
  /**
   * The cardholder disputed the charge with their bank, so the processor will
   * not refund it. The dispute decides where the money goes; a refund on top
   * would pay the cardholder twice.
   */
  Disputed: "disputed",
  /** Our credentials or setup are wrong. Never the user's fault. */
  Configuration: "configuration",
  /** Provider unreachable, timed out, or 5xx. Retryable. */
  Unavailable: "unavailable",
  Unknown: "unknown"
}, ms = "PAYMENT_ERROR", fs = "INTERNAL_SERVER_ERROR", hs = "PAYMENT_PROVIDER_MISMATCH", gs = {
  Monday: 0,
  Tuesday: 1,
  Wednesday: 2,
  Thursday: 3,
  Friday: 4,
  Saturday: 5,
  Sunday: 6
};
var Ft = /* @__PURE__ */ ((e) => (e.PreSpark = "PreSpark", e.NoPreSpark = "NoPreSpark", e.Spark = "Spark", e.NoSpark = "NoSpark", e.DidNotAttend = "DidNotAttend", e.Unmatched = "Unmatched", e.Declined = "Declined", e))(Ft || {}), Ut = /* @__PURE__ */ ((e) => (e.MatchedByMistake = "matched_by_mistake", e.BadInteraction = "bad_interaction", e.NoLongerInterested = "no_longer_interested", e))(Ut || {}), Vt = /* @__PURE__ */ ((e) => (e.Notify = "Notify", e.Register = "Register", e))(Vt || {}), S = /* @__PURE__ */ ((e) => (e.EventReminders = "EventReminders", e.Matches = "Matches", e.SparkInvitations = "SparkInvitations", e.NewEvents = "NewEvents", e))(S || {}), x = /* @__PURE__ */ ((e) => (e.Email = "Email", e.Text = "Text", e.TextAndEmail = "TextAndEmail", e.None = "None", e))(x || {});
const ps = [
  "spark-registration",
  "verify-phone-dialog",
  "settings"
], Gt = [
  "EventReminders",
  "Matches",
  "SparkInvitations"
  /* SparkInvitations */
], qt = (e) => Gt.includes(e), ys = (e, t) => {
  const n = oe(e);
  return t ? n ? "TextAndEmail" : "Email" : n ? "Text" : "None";
}, $e = (e, t) => {
  const n = Ce(e);
  return t ? n ? "TextAndEmail" : "Text" : n ? "Email" : "None";
}, bs = (e) => Object.fromEntries(
  Object.values(S).filter(qt).map((t) => [t, $e(e == null ? void 0 : e[t], !0)])
), Es = (e) => Object.fromEntries(
  Object.entries(e ?? {}).map(([t, n]) => [
    t,
    $e(n, !1)
  ])
), Ce = (e) => {
  const t = e ?? "Email";
  return t === "Email" || t === "TextAndEmail";
}, oe = (e) => e === "Text" || e === "TextAndEmail", Ts = (e) => Object.values(S).some(
  (t) => oe(e == null ? void 0 : e[t])
), ks = (e) => Ce(e) || oe(e);
var Yt = /* @__PURE__ */ ((e) => (e.Spark = "Spark", e))(Yt || {}), f = /* @__PURE__ */ ((e) => (e.EventPhoto = "EventPhoto", e.EventPrimary = "EventPrimary", e.EventHero = "EventHero", e))(f || {});
d.extend(re);
d.extend(se);
const ye = "America/New_York", vs = (e = void 0, t) => {
  const n = d(e).tz(ye), r = n.startOf("week").add(4, "day");
  let s = r.add(n.isBefore(r) ? 1 : 2, "week").startOf("week").add(1, "day");
  if (t) {
    const o = d(t.date).tz(ye).startOf("week").add(1, "day");
    s.isBefore(o) && (s = o);
  }
  return s;
};
d.extend(xe);
const Is = (e, t) => {
  let n = d(e), r = d(t);
  if (r < n) {
    const o = n;
    n = r, r = o;
  }
  let s = "";
  return n.isSame(r, "day") ? (s = n.format("dddd, MMM D") + " ", n.format("a") === r.format("a") ? s += `${n.format("h:mm")} - ${r.format("h:mma")}` : s += `${n.format("h:mma")} - ${r.format("h:mma")}`) : s = `${n.format("dddd, MMM D h:mma")} - ${r.format(
    "dddd, MMM D h:mma"
  )}`, s;
}, Ss = (e) => {
  const t = d(e);
  return `${t.format("dddd, MMM D")} ${t.format("h:mma")}`;
}, Ns = (e, t) => {
  let n = d(e), r = d(t);
  if (r < n) {
    const o = n;
    n = r, r = o;
  }
  let s = "";
  return n.isSame(r, "month") ? s = `${n.format("MMM D")} - ${r.format("D")}` : s = `${n.format("MMM D")} - ${r.format("MMM D")}`, s;
}, be = 21, Fe = (e, t, n) => {
  if (n && n.trim())
    return { text: n, display: n };
  if (!t) {
    const c = `${e}+`;
    return { text: c, display: `Ages ${c}` };
  }
  const r = e % 10 === 0 || e === be, s = t % 10 === 9, o = e === be ? 20 : e, a = t - 9, i = (a - o) / 10 + 1;
  if (r && s && i >= 2) {
    const c = [];
    for (let _ = o; _ <= a; _ += 10)
      c.push(`${_}s`);
    const l = c.length === 2 ? `${c[0]} and ${c[1]}` : `${c.slice(0, -1).join(", ")} and ${c[c.length - 1]}`;
    return { text: l, display: l };
  }
  const u = `${e}-${t}`;
  return { text: u, display: `Ages ${u}` };
}, Ue = "America/New_York", As = 7, Ms = 5242880, Kt = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term"
], ws = [
  // All categories are opt-out: an unset preference means subscribed. Senders
  // use `emailEnabledForCategory` (absence → treated as Email), so the toggle
  // shows ON until the user explicitly turns it off (which stores None).
  {
    title: "Event Reminders",
    description: "Remind me about events that I'm attending",
    type: S.EventReminders
  },
  {
    title: "Matches",
    description: "Let me know when someone likes me",
    type: S.Matches
  },
  {
    title: "Spark Invitations",
    description: "Let me know when a mutual Spark invites me to an event",
    type: S.SparkInvitations
  },
  {
    title: "New Events",
    description: "Send me the weekly email about upcoming events",
    type: S.NewEvents
  }
], Rs = [
  {
    description: "Email",
    value: x.Email
  },
  {
    description: "Text",
    value: x.Text
  },
  {
    description: "Text & Email",
    value: x.TextAndEmail
  },
  {
    description: "Off",
    value: x.None
  }
], Ds = "By opting in, you consent to receive recurring automated event reminder and notification text messages from Green Flag at the phone number provided. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to unsubscribe. Carriers are not liable for delayed or undelivered messages. See our Terms of Service and Privacy Policy.", Os = [
  "Terms of Service",
  "Privacy Policy"
], xs = "6a7610a579988969468cf544840d084b86a8e2c7e01dec967ad60adf6e1f588f", Ve = 0.089, ae = {
  [v.LifePartner]: {
    label: "Life Partner",
    valueCategory: y.Core
  },
  [v.LongTerm]: {
    label: "Long-term relationship",
    valueCategory: y.Core
  },
  [v.LongTermOpenToShortTerm]: {
    label: "Long-term, open to short-term",
    valueCategory: y.Core
  },
  [v.ShortTerm]: {
    label: "Short-term relationship",
    valueCategory: y.ShortTerm
  },
  [v.ShortTermOpenToLongTerm]: {
    label: "Short-term relationship, open to long-term",
    valueCategory: y.ShortTerm
  },
  [v.FiguringOutDatingGoals]: {
    label: "Figuring out my dating goals",
    valueCategory: y.Next
  }
}, Ge = {
  [y.Core]: {
    name: "Core Values",
    description: "These are the big things you want to be on the same page about with a partner-like trust, kindness, or a love of adventure."
  },
  [y.ShortTerm]: {
    name: "What I value in a short-term relationship",
    description: "Even short-term connections work best with the right fit. Share what you care about most-like fun nights out, clear boundaries, or great conversations!"
  },
  [y.Next]: {
    name: "What I value in my next relationship",
    description: "Even short-term connections work best with the right fit. Share what you care about most-like fun nights out, clear boundaries, or great conversations!"
  }
}, Ls = 100, Ps = 5, $s = (e) => encodeURIComponent(e), Cs = (e) => {
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, Fs = (e) => {
  const t = new URLSearchParams(e), n = {};
  for (const [r, s] of t) {
    const o = r.toLowerCase();
    s && Kt.includes(o) && (n[o] = s);
  }
  return n;
}, Us = (e) => {
  const t = [];
  return e.first_name && t.push("first_name"), e.email && t.push("email"), e.birth_date && t.push("birth_date"), e.gender && t.push("gender"), (e.gender_preference || e.friends_only) && t.push("gender_preference"), (e.phone_number_to_validate || e.phone_number) && t.push("phone_number_to_validate"), t;
}, Vs = (e) => {
  const t = [];
  return e.first_name || t.push("first_name"), e.email || t.push("email"), e.birth_date || t.push("birth_date"), e.gender || t.push("gender"), !e.gender_preference && !e.friends_only && t.push("gender_preference"), !e.phone_number_to_validate && !e.phone_number && t.push("phone_number_to_validate"), t;
}, qe = (e, t) => Math.round(e * (t * 100)) / 100, Ht = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), w = (e) => Ht.format(e), E = (e) => w(e / 100), Gs = (e, t = "") => e === null ? t : (e / 100).toFixed(2), Bt = /^-?(\d+\.?\d*|\.\d+)$/, qs = (e) => {
  const t = e.trim();
  return Bt.test(t) ? Math.round(Number(t) * 100) : null;
}, Ys = (e) => /^[=+\-@\t\r]/.test(e) ? `'${e}` : e, jt = [
  "published",
  "starts"
], Wt = 366, zt = 24 * 60 * 60 * 1e3, Z = (e, t) => {
  const n = e.anchor === "starts" ? t.starts_at : t.first_published_at;
  if (!n)
    return null;
  const r = Date.parse(n);
  return Number.isNaN(r) ? null : new Date(r + e.offset_days * zt).toISOString();
}, Q = (e) => {
  if (e == null)
    return null;
  if (typeof e != "object")
    return !1;
  const { anchor: t, offset_days: n } = e;
  return !jt.includes(t) || typeof n != "number" || !Number.isInteger(n) || Math.abs(n) > Wt || t === "published" && n < 0 ? !1 : { anchor: t, offset_days: n };
}, Ee = (e) => e === 1 ? "1 day" : `${e} days`, Ks = (e) => {
  const t = e.anchor === "starts" ? "the event starts" : "the event is published";
  return e.offset_days === 0 ? `When ${t}` : e.offset_days < 0 ? `${Ee(-e.offset_days)} before ${t}` : `${Ee(e.offset_days)} after ${t}`;
}, Hs = (e, t) => e == null || t == null ? e == t : e.anchor === t.anchor && e.offset_days === t.offset_days, Ye = (e) => e.discount_percent !== null ? { kind: "percent", percent: e.discount_percent } : { kind: "amount", cents: e.discount_cents }, Xt = (e) => {
  const t = e.discount_cents != null, n = e.discount_percent != null;
  if (t === n)
    return { ok: !1, error: "INVALID_DISCOUNT" };
  if (t) {
    const s = e.discount_cents ? parseInt(String(e.discount_cents)) : NaN;
    return isNaN(s) || s <= 0 ? { ok: !1, error: "INVALID_DISCOUNT_CENTS" } : { ok: !0, discount: { discount_cents: s, discount_percent: null } };
  }
  const r = e.discount_percent;
  return typeof r == "number" && Number.isInteger(r) && r >= 1 && r <= 100 ? { ok: !0, discount: { discount_cents: null, discount_percent: r } } : { ok: !1, error: "INVALID_DISCOUNT_PERCENT" };
}, Bs = (e) => {
  const t = Ye(e);
  return t.kind === "percent" ? `${t.percent}%` : w(t.cents / 100);
}, js = (e) => e === e.toUpperCase(), Zt = (e) => e.discount_percent !== null ? { discount_cents: null, discount_percent: e.discount_percent } : { discount_cents: e.discount_cents, discount_percent: null }, Ws = (e) => ({
  code: e.code,
  description: e.description,
  first_spark_only: e.first_spark_only,
  enabled_at: e.enabled_at,
  expires_at: e.expires_at,
  enabled_rule: e.enabled_rule,
  expires_rule: e.expires_rule,
  ...Zt(e)
}), zs = (e, t, n = /* @__PURE__ */ new Date()) => ({
  enabled_at: e.enabled_rule && Z(e.enabled_rule, t) || e.enabled_at || n.toISOString(),
  expires_at: e.expires_rule ? Z(e.expires_rule, t) : e.expires_at ?? null
}), Qt = (e) => {
  const { code: t, description: n, first_spark_only: r } = e;
  if (typeof t != "string" || !t.trim())
    return { ok: !1, error: "INVALID_CODE" };
  if (typeof n != "string" || !n.trim())
    return { ok: !1, error: "INVALID_DESCRIPTION" };
  const s = Xt(e);
  if (!s.ok)
    return s;
  const o = Q(e.enabled_rule);
  if (o === !1)
    return { ok: !1, error: "INVALID_ENABLED_RULE" };
  const a = Q(e.expires_rule);
  return a === !1 ? { ok: !1, error: "INVALID_EXPIRES_RULE" } : {
    ok: !0,
    terms: {
      code: t.trim().toUpperCase(),
      description: n.trim(),
      first_spark_only: !!r,
      enabled_rule: o,
      expires_rule: a,
      ...s.discount
    }
  };
}, Xs = (e) => {
  if (!Array.isArray(e))
    return { ok: !1, error: "INVALID_COUPONS" };
  const t = [];
  for (const n of e) {
    if (typeof n != "object" || n === null || Array.isArray(n))
      return { ok: !1, error: "INVALID_COUPONS" };
    const r = Qt(n);
    if (!r.ok)
      return r;
    t.push(r.terms);
  }
  return new Set(t.map((n) => n.code)).size !== t.length ? { ok: !1, error: "DUPLICATE_COUPON_CODE" } : { ok: !0, coupons: t };
}, O = (e) => Math.round(e * 100) / 100, Jt = (e, t) => e.kind === "percent" ? Math.round(Math.round(t * 100) * e.percent / 100) : e.cents, en = (e, t = {}) => {
  const { discount: n, coupon: r, taxRate: s = Ve } = t, o = Math.max(0, e), a = n ? Math.min(o, Math.max(0, n.price)) : o, i = r ? Jt(Ye(r), a) : 0, u = O(
    Math.min(a, Math.max(0, i / 100))
  ), c = O(a - u), l = qe(c, s);
  return {
    listPrice: o,
    discount: n ? {
      description: n.label,
      amount: O(o - a)
    } : null,
    coupon: r ? { description: r.description, amount: O(u) } : null,
    subtotal: c,
    tax: l,
    total: O(c + l)
  };
}, Zs = (e) => {
  const t = en(e);
  return {
    price: w(t.subtotal),
    tax: w(t.tax),
    total: w(t.total)
  };
}, Ke = 1e7, C = (e, t) => typeof e == "number" && Number.isInteger(e) && e >= t && e <= Ke, F = {
  invoice_arrangement: null,
  invoice_exclusive: !1,
  invoice_ticket_fee_cents: null,
  invoice_host_fee_cents: null,
  invoice_monthly_minimum_cents: null,
  invoice_attendee_fee_cents: null
}, tn = Object.keys(
  F
), Qs = (e) => {
  const t = e.invoice_arrangement;
  if (t === null)
    return { ok: !0, columns: F };
  if (t !== "partner_marketed" && t !== "green_flag_marketed")
    return { ok: !1, error: "INVALID_INVOICE_ARRANGEMENT" };
  const n = e.invoice_exclusive ?? !1;
  if (typeof n != "boolean")
    return { ok: !1, error: "INVALID_INVOICE_EXCLUSIVE" };
  if (t === "green_flag_marketed")
    return C(e.invoice_attendee_fee_cents, 0) ? {
      ok: !0,
      columns: {
        ...F,
        invoice_arrangement: t,
        invoice_exclusive: n,
        invoice_attendee_fee_cents: e.invoice_attendee_fee_cents
      }
    } : { ok: !1, error: "INVALID_ATTENDEE_FEE" };
  if (!C(e.invoice_ticket_fee_cents, 0))
    return { ok: !1, error: "INVALID_TICKET_FEE" };
  if (!C(e.invoice_host_fee_cents, 0))
    return { ok: !1, error: "INVALID_HOST_FEE" };
  const r = n ? e.invoice_monthly_minimum_cents ?? null : null;
  return r !== null && !C(r, 1) ? { ok: !1, error: "INVALID_MONTHLY_MINIMUM" } : {
    ok: !0,
    columns: {
      ...F,
      invoice_arrangement: t,
      invoice_exclusive: n,
      invoice_ticket_fee_cents: e.invoice_ticket_fee_cents,
      invoice_host_fee_cents: e.invoice_host_fee_cents,
      invoice_monthly_minimum_cents: r
    }
  };
}, nn = (e) => ({
  invoice_arrangement: e.invoice_arrangement,
  invoice_exclusive: e.invoice_exclusive,
  invoice_ticket_fee_cents: e.invoice_ticket_fee_cents,
  invoice_host_fee_cents: e.invoice_host_fee_cents,
  invoice_monthly_minimum_cents: e.invoice_monthly_minimum_cents,
  invoice_attendee_fee_cents: e.invoice_attendee_fee_cents
}), Js = (e) => {
  const t = nn(e), {
    invoice_arrangement: n,
    invoice_ticket_fee_cents: r,
    invoice_host_fee_cents: s,
    invoice_attendee_fee_cents: o
  } = t;
  if (n === null)
    return null;
  if (n === "partner_marketed") {
    if (r === null || s === null)
      throw new Error("partner-marketed terms without a ticket or host fee");
    return {
      ...t,
      invoice_arrangement: n,
      invoice_ticket_fee_cents: r,
      invoice_host_fee_cents: s
    };
  }
  if (o === null)
    throw new Error("Green Flag-marketed terms without an attendee fee");
  return {
    ...t,
    invoice_arrangement: n,
    invoice_attendee_fee_cents: o
  };
}, eo = (e, t) => tn.every((n) => e[n] === t[n]), k = [
  "dedicated_email",
  "instagram_post",
  "instagram_story",
  "email_social_bundle"
], rn = {
  dedicated_email: {
    name: "Dedicated email",
    unit: "send",
    standardRateCents: 1e4,
    maxPerEvent: null
  },
  instagram_post: {
    name: "Instagram post or collaboration",
    unit: "post",
    standardRateCents: 12500,
    maxPerEvent: null
  },
  instagram_story: {
    name: "Instagram story or story share",
    unit: "story",
    standardRateCents: 3500,
    maxPerEvent: null
  },
  email_social_bundle: {
    name: "Email + social bundle",
    unit: "event",
    standardRateCents: 22500,
    maxPerEvent: 1
  }
}, H = (e) => ({
  key: e,
  ...rn[e]
}), sn = k.map(H), on = 20, ie = (e) => k.includes(e), ce = (e, t) => e[t] ?? H(t).standardRateCents, an = (e) => typeof e == "number" && Number.isInteger(e) && e >= 0 && e <= Ke, to = (e) => {
  if (typeof e != "object" || e === null || Array.isArray(e))
    return { ok: !1, error: "INVALID_MARKETING_RATES" };
  const t = {};
  for (const [n, r] of Object.entries(e)) {
    if (!ie(n))
      return { ok: !1, error: "INVALID_MARKETING_RATES" };
    if (r != null) {
      if (!an(r))
        return { ok: !1, error: "INVALID_MARKETING_RATE" };
      t[n] = r;
    }
  }
  return { ok: !0, rates: t };
}, no = (e) => {
  if (!Array.isArray(e))
    return { ok: !1, error: "INVALID_MARKETING_ITEMS" };
  const t = [];
  for (const n of e) {
    if (typeof n != "object" || n === null)
      return { ok: !1, error: "INVALID_MARKETING_ITEMS" };
    const { item: r, quantity: s } = n;
    if (!ie(r))
      return { ok: !1, error: "UNKNOWN_MARKETING_ITEM" };
    if (!He(r, s))
      return { ok: !1, error: "INVALID_MARKETING_QUANTITY" };
    if (t.some((o) => o.item === r))
      return { ok: !1, error: "DUPLICATE_MARKETING_ITEM" };
    t.push({ item: r, quantity: s });
  }
  return { ok: !0, items: t };
}, He = (e, t) => typeof t == "number" && Number.isInteger(t) && t >= 1 && t <= (H(e).maxPerEvent ?? on), ro = (e, t) => {
  if (!ie(e))
    return { ok: !1, error: "UNKNOWN_MARKETING_ITEM" };
  if (typeof t != "object" || t === null || !("done_quantity" in t))
    return { ok: !1, error: "INVALID_MARKETING_QUANTITY" };
  const n = t.done_quantity;
  return n !== 0 && !He(e, n) ? { ok: !1, error: "INVALID_MARKETING_QUANTITY" } : { ok: !0, item: e, doneQuantity: n };
}, cn = (e) => e.invoice_arrangement !== "green_flag_marketed", so = (e) => ({
  offered: cn(e),
  items: sn.map((t) => ({
    ...t,
    rateCents: ce(e.invoice_marketing_rates, t.key)
  }))
}), Be = (e, t, n) => {
  const r = e[t];
  if (!r)
    return e;
  const s = { ...r, [n]: null }, o = { ...e };
  return s.requested === null && s.done === null ? delete o[t] : o[t] = s, o;
}, oo = (e, t, n, r) => {
  var o;
  let s = e;
  for (const a of k)
    t.some((i) => i.item === a) || (s = Be(s, a, "requested"));
  for (const { item: a, quantity: i } of t) {
    const u = s[a];
    s = {
      ...s,
      [a]: {
        rate_cents: je(
          ce(n, a),
          u,
          i
        ),
        requested: { quantity: i, at: ((o = u == null ? void 0 : u.requested) == null ? void 0 : o.at) ?? r },
        done: (u == null ? void 0 : u.done) ?? null
      }
    };
  }
  return s;
}, ao = (e, t, n, r, s, o) => {
  var i;
  const a = e[t];
  return n === 0 ? a != null && a.done ? Be(e, t, "done") : e : ((i = a == null ? void 0 : a.done) == null ? void 0 : i.quantity) === n ? e : {
    ...e,
    [t]: {
      rate_cents: (a == null ? void 0 : a.rate_cents) ?? ce(r, t),
      requested: (a == null ? void 0 : a.requested) ?? null,
      done: {
        quantity: n,
        at: o,
        by_user_id: s
      }
    }
  };
}, ln = (e) => k.flatMap((t) => {
  var r;
  const n = (r = e[t]) == null ? void 0 : r.requested;
  return n ? [{ item: t, quantity: n.quantity }] : [];
}), io = (e) => k.some((t) => e[t] !== void 0), co = (e) => k.some((t) => {
  var n;
  return (n = e[t]) == null ? void 0 : n.done;
}), lo = (e, t) => t.some(
  ({ item: n, quantity: r }) => {
    var s, o;
    return r > (((o = (s = e[n]) == null ? void 0 : s.requested) == null ? void 0 : o.quantity) ?? 0);
  }
), uo = (e, t, n) => {
  var r, s;
  return n > (((s = (r = e[t]) == null ? void 0 : r.done) == null ? void 0 : s.quantity) ?? 0);
}, _o = (e, t) => e.length === t.length && e.every(
  ({ item: n, quantity: r }) => t.some((s) => s.item === n && s.quantity === r)
), je = (e, t, n) => {
  var r;
  return t && (t.done !== null || ((r = t.requested) == null ? void 0 : r.quantity) === n) ? t.rate_cents : e;
}, mo = (e, t, n = ln(t)) => e.items.map((r) => {
  var a, i;
  const s = t[r.key], o = ((a = n.find((u) => u.item === r.key)) == null ? void 0 : a.quantity) ?? 0;
  return {
    item: r,
    rateCents: je(r.rateCents, s, o),
    asked: o,
    done: ((i = s == null ? void 0 : s.done) == null ? void 0 : i.quantity) ?? 0
  };
}), fo = (e) => e.reduce((t, n) => t + n.asked * n.rateCents, 0), ho = (e) => e.reduce((t, n) => t + n.done * n.rateCents, 0);
d.extend(re);
d.extend(se);
const We = 2.9, ze = 30, Te = `${We}% + ${E(
  ze
)}`, un = 3, dn = /^\d{4}-(0[1-9]|1[0-2])$/, go = (e) => typeof e == "string" && dn.test(e), _n = (e) => d(e).tz(Ue).format("YYYY-MM"), B = (e, t) => d(`${e}-01T12:00:00Z`).utc().add(t, "month").format("YYYY-MM"), mn = (e) => d.tz(`${e}-01 00:00`, Ue).toISOString(), fn = (e) => mn(B(e, 1)), po = (e) => d(`${e}-01T12:00:00Z`).utc().format("MMMM YYYY"), Xe = (e, t) => `GF-${e.slice(2, 4)}${e.slice(5, 7)}-${t}`, yo = (e, t) => {
  const n = [];
  for (let r = e; r <= t; r = B(r, 1))
    n.push(r);
  return n;
}, hn = (e) => Math.round(qe(e / 100, Ve) * 100), gn = (e) => Math.round(
  (e + hn(e)) * We / 100
) + ze, g = (e, t, n = `${t}s`) => e === 1 ? t : n, pn = {
  story: "stories"
}, yn = (e, t) => g(t, e, pn[e] ?? `${e}s`), m = (e) => e.reduce((t, n) => t + n, 0), h = (e) => 0 - e, bn = (e) => m(
  k.map((t) => {
    const n = e[t];
    return n != null && n.done ? n.done.quantity * n.rate_cents : 0;
  })
), En = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const n of k)
    for (const r of e) {
      const s = r.marketing[n];
      if (!(s != null && s.done))
        continue;
      const o = `${n}:${s.rate_cents}`, a = t.get(o) ?? {
        item: n,
        rate: s.rate_cents,
        quantity: 0,
        event_quantities: []
      };
      a.quantity += s.done.quantity, a.event_quantities.push({
        spark_id: r.spark_id,
        quantity: s.done.quantity
      }), t.set(o, a);
    }
  return [...t.values()].map(
    ({ item: n, rate: r, quantity: s, event_quantities: o }) => {
      const a = H(n);
      return {
        key: "marketing",
        label: a.name,
        detail: "Marketing",
        quantity: s,
        unit: yn(a.unit, s),
        rate: E(r),
        unit_price_cents: h(r),
        amount_cents: h(s * r),
        marketing_item: n,
        event_quantities: o
      };
    }
  );
}, Tn = (e, t) => e.starts_at.localeCompare(t.starts_at) || e.spark_id - t.spark_id, Ze = (e) => ({
  spark_id: e.spark_id,
  name: e.name,
  starts_at: e.starts_at,
  ends_at: e.ends_at,
  canceled: e.canceled
}), kn = (e, t) => {
  const n = e.charges.filter((l) => !l.refunded), r = n.length, s = m(n.map((l) => l.subtotal_cents)), o = r * t.invoice_ticket_fee_cents, a = m(
    e.charges.map(
      (l) => (l.processing_fee_cents ?? gn(l.subtotal_cents)) + (l.refunded ? l.refund_processing_fee_cents ?? 0 : 0)
    )
  ), i = e.canceled ? 0 : e.host_count, u = i * t.invoice_host_fee_cents, c = bn(e.marketing);
  return {
    ...Ze(e),
    tickets: r,
    refunded: e.charges.length - r,
    sales_cents: s,
    ticket_fee_cents: o,
    card_fee_cents: a,
    host_count: i,
    host_fee_cents: u,
    marketing_cents: c,
    net_cents: s - o - a - u - c
  };
}, vn = (e, t) => ({
  ...Ze(e),
  registered: e.registered,
  checked_in: e.checked_in,
  no_shows: Math.max(0, e.registered - e.checked_in),
  attendee_fee_cents: e.checked_in * t.invoice_attendee_fee_cents
}), ke = (e) => m(e.map((t) => t.amount_cents)), bo = (e) => e.id ?? (e.key === "marketing" ? `${e.key}:${e.marketing_item}:${e.rate}` : e.key), Eo = (e) => {
  const t = [...e.events].sort(Tn), n = {
    organization_id: e.organization.id,
    organization_name: e.organization.name,
    number: Xe(e.month, e.organization.id),
    month: e.month,
    status: "draft",
    ...Mn(e.month, t),
    finalized_at: null
  }, { terms: r } = e;
  if (r.invoice_arrangement === "partner_marketed") {
    const a = t.map(
      (u) => kn(u, r)
    ), i = [
      ...Sn(r, t, a),
      ...ve(e)
    ];
    return {
      ...n,
      arrangement: r.invoice_arrangement,
      terms: r,
      events: a,
      lines: i,
      balance_cents: ke(i)
    };
  }
  const s = t.map(
    (a) => vn(a, r)
  ), o = [
    ...Nn(r, s),
    ...ve(e)
  ];
  return {
    ...n,
    arrangement: r.invoice_arrangement,
    terms: r,
    events: s,
    lines: o,
    balance_cents: ke(o)
  };
}, In = (e, t) => {
  const n = m(t.map((c) => c.refunded)), r = m(t.map((c) => c.tickets)) + n, s = e.flatMap((c) => c.charges).filter((c) => c.processing_fee_cents != null).length, o = r - s, a = e.some(
    (c) => c.charges.some(
      (l) => l.refunded && (l.refund_processing_fee_cents ?? 0) !== 0
    )
  ), i = [
    n ? `Includes ${n} refunded ${g(n, "charge")}` : "Per charge, tax included"
  ];
  (s || a) && i.push(
    o ? `${s} actual; ${o} estimated at ${Te}` : `${s} actual`
  ), a && i.push("Refund fees/credits included");
  let u = "Mixed";
  return !s && !a ? u = Te : s && !o && (u = "Actual fees"), {
    key: "card_fees",
    label: "Card processing",
    detail: i.join(". "),
    quantity: r,
    unit: g(r, "charge"),
    rate: u,
    amount_cents: h(
      m(t.map((c) => c.card_fee_cents))
    )
  };
}, Sn = (e, t, n) => {
  const r = e.invoice_ticket_fee_cents, s = e.invoice_host_fee_cents, o = m(n.map((_) => _.tickets)), a = m(n.map((_) => _.ticket_fee_cents)), i = m(n.map((_) => _.host_count)), u = n.length, c = [
    {
      key: "ticket_sales",
      label: "Ticket sales",
      detail: `${u} ${g(
        u,
        "event"
      )}, before tax, refunds excluded`,
      quantity: o,
      unit: g(o, "ticket"),
      rate: null,
      amount_cents: m(n.map((_) => _.sales_cents))
    },
    {
      key: "ticket_fee",
      label: "Green Flag ticket fee",
      detail: "Per ticket sold",
      quantity: o,
      unit: g(o, "ticket"),
      rate: E(r),
      unit_price_cents: h(r),
      amount_cents: h(a)
    },
    In(t, n)
  ];
  i && c.push({
    key: "host_fees",
    label: "Green Flag hosts",
    detail: "Per host, per event",
    quantity: i,
    unit: g(i, "host"),
    rate: E(s),
    unit_price_cents: h(s),
    amount_cents: h(
      m(n.map((_) => _.host_fee_cents))
    )
  });
  const l = e.invoice_exclusive ? e.invoice_monthly_minimum_cents : null;
  if (l) {
    const _ = Math.max(0, l - a);
    c.push({
      key: "minimum_shortfall",
      label: "Monthly minimum shortfall",
      detail: _ ? `${E(l)} minimum less ${E(
        a
      )} in ticket fees` : `${E(a)} in ticket fees, so nothing is added`,
      quantity: null,
      unit: null,
      rate: `${E(l)} minimum`,
      amount_cents: h(_)
    });
  }
  return c.push(...En(t)), c;
}, ve = (e) => {
  const t = [], n = e.late_refunds;
  if (n.length) {
    const r = n.length;
    t.push({
      key: "late_refunds",
      label: "Refunds after an earlier invoice",
      detail: n.some((s) => s.refund_processing_fee_cents) ? "Ticket sales returned, less the ticket fee, plus refund fees or credits" : "Ticket sales returned, less the ticket fee",
      quantity: r,
      unit: g(r, "refund"),
      rate: null,
      amount_cents: h(
        m(
          n.map(
            (s) => s.subtotal_cents - s.ticket_fee_cents + (s.refund_processing_fee_cents ?? 0)
          )
        )
      )
    });
  }
  return e.carried_in_cents < 0 && t.push({
    key: "carried_in",
    label: "Carried from last month",
    detail: Xe(
      B(e.month, -1),
      e.organization.id
    ),
    quantity: null,
    unit: null,
    rate: null,
    amount_cents: e.carried_in_cents
  }), t;
}, Nn = (e, t) => {
  const n = e.invoice_attendee_fee_cents, r = m(t.map((o) => o.checked_in)), s = m(t.map((o) => o.no_shows));
  return [
    {
      key: "attendee_fees",
      label: "Checked-in guests",
      detail: s ? `${s} registered ${g(
        s,
        "guest"
      )} did not check in and ${g(s, "is", "are")} not billed` : "Each guest who checked in",
      quantity: r,
      unit: g(r, "guest"),
      rate: E(n),
      unit_price_cents: h(n),
      amount_cents: h(
        m(t.map((o) => o.attendee_fee_cents))
      )
    }
  ];
}, An = (e) => e.ends_at ?? d(e.starts_at).add(un, "hour").toISOString(), Mn = (e, t) => {
  let n = {
    at: d(fn(e)),
    spark_id: null
  };
  for (const r of t) {
    if (r.canceled)
      continue;
    const s = d(An(r));
    s.isAfter(n.at) && (n = { at: s, spark_id: r.spark_id });
  }
  return {
    finalizes_at: n.at.toISOString(),
    finalizing_spark_id: n.spark_id
  };
}, To = (e, t) => {
  const n = (s) => {
    const o = t(s);
    return o !== void 0 && new Date(o) <= new Date(e.refunded_at);
  };
  if (!n(e.event_month))
    return null;
  const r = _n(e.refunded_at);
  return n(r) ? B(r, 1) : r;
}, ko = (e) => e.balance_cents > 0 ? "payout" : e.balance_cents === 0 ? "none" : e.arrangement === "partner_marketed" ? "carried" : "due", Ie = 1e8, wn = 1e6, Rn = 200, Dn = (e, t) => typeof e != "number" || !Number.isInteger(e) || e < 0 || e > wn || typeof t != "number" || !Number.isInteger(t) || Math.abs(t) > Ie || Math.abs(e * t) > Ie ? null : { quantity: e, unit_price_cents: t }, vo = (e) => {
  if (!e || typeof e != "object" || Array.isArray(e))
    return { ok: !1, error: "INVALID_INVOICE_LINE" };
  const {
    id: t,
    label: n,
    quantity: r,
    unit_price_cents: s
  } = e;
  if (t !== void 0 && (typeof t != "string" || !t || t.length > 200))
    return { ok: !1, error: "INVALID_INVOICE_LINE" };
  if (n !== void 0 && (typeof n != "string" || !n.trim() || n.trim().length > Rn))
    return { ok: !1, error: "INVALID_LINE_LABEL" };
  const o = n == null ? void 0 : n.trim();
  if (r !== void 0 || s !== void 0) {
    const a = Dn(r, s);
    if (!a)
      return { ok: !1, error: "INVALID_LINE_PRICE_OR_QUANTITY" };
    if (t !== void 0)
      return {
        ok: !0,
        update: {
          id: t,
          ...a,
          ...o !== void 0 ? { label: o } : {}
        }
      };
    if (o !== void 0)
      return { ok: !0, update: { label: o, ...a } };
  } else if (t !== void 0 && o !== void 0)
    return { ok: !0, update: { id: t, label: o } };
  return { ok: !1, error: "INVALID_INVOICE_LINE" };
}, Qe = (e, t) => {
  const { label: n } = e, r = e.price, s = Q(e.expires_rule);
  return typeof r != "number" || !Number.isFinite(r) || typeof n != "string" || !n.trim() || s === !1 ? { ok: !1, error: "INVALID_DISCOUNT" } : t == null || r < 0 || r > t ? { ok: !1, error: "INVALID_DISCOUNT_PRICE" } : {
    ok: !0,
    price: r,
    label: n.trim(),
    rule: s
  };
}, Io = (e, t) => {
  if (e === null)
    return { ok: !0, discount: null };
  if (typeof e != "object" || Array.isArray(e))
    return { ok: !1, error: "INVALID_DISCOUNT" };
  const n = Qe(e, t);
  if (!n.ok)
    return n;
  const r = e.expires_at ?? null;
  return r !== null && (typeof r != "string" || Number.isNaN(Date.parse(r))) ? { ok: !1, error: "INVALID_DISCOUNT" } : {
    ok: !0,
    discount: {
      price: n.price,
      label: n.label,
      // With a rule, the rule decides the date: `resolveSparkDiscount`.
      expires_at: n.rule ? null : r && new Date(r).toISOString(),
      expires_rule: n.rule
    }
  };
}, On = (e, t) => {
  if (e === null)
    return { ok: !0, discount: null };
  if (typeof e != "object" || Array.isArray(e))
    return { ok: !1, error: "INVALID_DISCOUNT" };
  const n = Qe(e, t);
  return n.ok ? {
    ok: !0,
    discount: { price: n.price, label: n.label, expires_rule: n.rule }
  } : n;
}, So = (e, t) => e.expires_rule ? {
  ...e,
  expires_at: Z(e.expires_rule, t)
} : e, No = (e) => ({
  price: e.price,
  label: e.label,
  expires_rule: e.expires_rule
}), xn = (e) => ({
  price: e.price,
  label: e.label,
  expires_at: null,
  expires_rule: e.expires_rule
}), Ao = (e, t) => e && On(e, t).ok ? xn(e) : null, Mo = (e, t = /* @__PURE__ */ new Date()) => e.discount && (!e.discount.expires_at || Date.parse(e.discount.expires_at) > t.getTime()) ? e.discount : null, wo = (e) => ae[e].label, Ro = (e) => {
  const { valueCategory: t } = ae[e];
  return Ge[t].name;
}, Do = (e) => {
  const { valueCategory: t } = ae[e];
  return Ge[t].description;
}, Ln = (e) => e.men + e.women + e.other, Pn = (e) => {
  const t = [];
  return e.capacity_men !== null && e.registrationSummary.men >= e.capacity_men && t.push("men"), e.capacity_women !== null && e.registrationSummary.women >= e.capacity_women && t.push("women"), Ln(e.registrationSummary) >= e.capacity && t.push("everyone"), t;
}, $n = (e, t) => {
  const n = e == null ? void 0 : e.toLowerCase();
  return n === "woman" && t.capacity_women !== null && t.registrationSummary.women >= t.capacity_women || n === "man" && t.capacity_men !== null && t.registrationSummary.men >= t.capacity_men;
}, Cn = (e, t) => (t.min_age === 0 || e >= t.min_age) && (t.max_age === 0 || e <= t.max_age), Oo = (e, t) => {
  if (e.birth_date != null) {
    const n = d().diff(d(e.birth_date), "years");
    if (!Cn(n, t))
      return !1;
  }
  return !(Pn(t).includes("everyone") || $n(e.gender ?? void 0, t));
}, Je = new RegExp("^(?:\\p{Extended_Pictographic}|‍|️|\\s)+", "u"), xo = (e) => e.replace(Je, "").trim(), Lo = (e) => {
  var t;
  return (((t = e.match(Je)) == null ? void 0 : t[0]) ?? "").trim();
}, Fn = [
  {
    // An event with a CMS activity but no typed title is normal: the API
    // stamps the activity's name as the title on save. Either one satisfies
    // this, which is why the error code names both.
    key: "TITLE_OR_CMS_ACTIVITY_ID",
    label: "Title",
    met: (e) => !!e.title || e.cms_activity_id != null
  },
  {
    // The venue is where `location` and `google_maps_place_id` come from, so
    // requiring it covers the whole "where is this" question.
    key: "CMS_VENUE_ID",
    label: "Venue",
    met: (e) => e.cms_venue_id != null
  },
  {
    key: "STARTS_AT",
    label: "Starts",
    met: (e) => !!e.starts_at
  },
  {
    key: "ENDS_AT",
    label: "Ends",
    met: (e) => !!e.ends_at
  },
  {
    // Free events are real, so 0 is a price and not an absence. Only NULL
    // means unset.
    key: "PRICE",
    label: "Price",
    met: (e) => e.price != null
  },
  {
    // A published event with no spots would be open for registration and
    // full at the same moment.
    key: "CAPACITY",
    label: "Total spots",
    met: (e) => e.capacity != null && e.capacity >= 1
  },
  {
    // Both bounds, together: 0 is the "no limit" sentinel isAgeWithinSparkWindow
    // reads, so an unset bound cannot be expressed as 0 and has to be NULL.
    key: "AGE_RANGE",
    label: "Age range",
    met: (e) => e.min_age != null && e.max_age != null
  },
  {
    key: "PRIMARY_IMAGE",
    label: "Event image",
    met: (e) => !!e.primary_image
  },
  {
    key: "OVERVIEW_PREVIEW",
    label: "Overview",
    met: (e) => !!e.overview_preview
  },
  {
    key: "WHATS_INCLUDED",
    label: "What's included",
    met: (e) => !!e.whats_included
  }
], Po = (e) => Fn.filter((t) => !t.met(e)), Un = (e) => e === R.PreRegister || e === R.Active, $o = Object.values(R).filter(Un), Vn = [
  "title",
  "cms_activity_id",
  "cms_venue_id",
  "event_kind",
  "audience",
  "gender_balanced",
  "capacity",
  "price",
  "min_age",
  "max_age",
  "age_range_label",
  "overview_preview",
  "overview_read_more",
  "whats_included",
  "wants_hosts",
  "requested_host_count"
], Co = (e) => Object.fromEntries(
  Vn.map((t) => [t, e[t]])
), Fo = (e, t) => {
  const n = {};
  return e.venueIds.length === 1 && t.cms_venue_id == null && (n.cms_venue_id = e.venueIds[0]), e.activityIds.length === 1 && t.cms_activity_id == null && (n.cms_activity_id = e.activityIds[0]), n;
}, Uo = [
  "event_kind",
  "audience",
  "gender_balanced",
  "capacity"
], Gn = [
  b.Straight,
  b.LgbtqAll,
  b.Anyone
], J = (e) => e.event_kind === Y.Social && e.audience != null && Gn.includes(e.audience), et = (e) => e.audience === b.LgbtqMen ? "men" : e.audience === b.LgbtqWomen ? "women" : (e.event_kind === Y.Social ? J(e) && e.gender_balanced === !0 : e.audience === b.Straight) ? "even" : "open", qn = (e) => e.capacity == null || et(e) !== "even" || e.capacity % 2 === 0, j = { capacity_men: null, capacity_women: null }, Vo = (e) => {
  const { capacity: t } = e;
  if (t == null)
    return j;
  switch (et(e)) {
    case "even":
      return t % 2 === 0 ? { capacity_men: t / 2, capacity_women: t / 2 } : j;
    case "men":
      return { capacity_men: t, capacity_women: 0 };
    case "women":
      return { capacity_men: 0, capacity_women: t };
    case "open":
      return j;
  }
}, Go = (e) => e == null || e <= 30 ? 1 : e <= 50 ? 2 : 3, qo = (e) => e.submission_status != null && e.submission_status !== K.Approved && e.status === R.Draft, Yo = (e) => e.status === R.Draft && e.submission_status === K.Submitted, Ko = (e) => e.submission_status != null && e.submission_status !== K.Draft, Yn = (e, t = /* @__PURE__ */ new Date()) => new Date(e.starts_at).getTime() > t.getTime(), Ho = 3, Se = (e) => {
  const t = /* @__PURE__ */ new Date();
  return (e.proposed_dates ?? []).filter(
    (n) => Yn(n, t)
  );
}, Kn = (e) => e.min_age == null || e.max_age == null || e.min_age <= e.max_age, Hn = [
  {
    key: "EVENT_KIND",
    label: "Event type",
    met: (e) => !!e.event_kind
  },
  {
    key: "AUDIENCE",
    label: "Who it's for",
    met: (e) => !!e.audience
  },
  {
    key: "GENDER_BALANCE",
    label: "Gender balance",
    applies: J,
    met: (e) => !J(e) || e.gender_balanced != null
  },
  {
    key: "TITLE",
    label: "Title",
    met: (e) => !!e.title
  },
  {
    key: "VENUE",
    label: "Venue",
    met: (e) => e.cms_venue_id != null
  },
  {
    // Only a date still to come counts: a draft left until its dates have
    // passed has nothing Green Flag could approve it onto.
    key: "FIRST_CHOICE_DATE",
    label: "First-choice date",
    met: (e) => Se(e).length >= 1
  },
  {
    key: "BACKUP_DATE",
    label: "At least one back-up date",
    met: (e) => Se(e).length >= 2
  },
  {
    // Free is a price; below free is not one. The field rules accept any
    // number because a draft may be half-written, so this is where a
    // negative price stops.
    key: "PRICE",
    label: "Price",
    met: (e) => e.price != null && e.price >= 0
  },
  {
    // An event that splits its spots evenly needs an even total, so an odd
    // total is as unfinished as no total.
    key: "CAPACITY",
    label: "Total spots",
    met: (e) => e.capacity != null && e.capacity >= 2 && qn(e)
  },
  {
    // Green Flag groups dating events by age; a social event can welcome
    // everyone. Whatever the kind, a range that is given has to run the right
    // way: a youngest age above the oldest is as unfinished as none.
    key: "AGE_RANGE",
    label: "Age range",
    met: (e) => Kn(e) && (e.event_kind !== Y.Dating || e.min_age != null && e.max_age != null)
  },
  {
    key: "OVERVIEW_PREVIEW",
    label: "Overview",
    met: (e) => !!e.overview_preview
  },
  {
    key: "WHATS_INCLUDED",
    label: "What's included",
    met: (e) => !!e.whats_included
  }
], Bn = (e) => Hn.filter(
  (t) => !("applies" in t) || t.applies(e)
).map((t) => ({ requirement: t, met: t.met(e) })), Bo = (e) => Bn(e).filter((t) => !t.met).map((t) => t.requirement), jn = (e, t) => {
  const n = {};
  for (const r of t)
    r in e && (n[r] = e[r]);
  return n;
}, P = 15, Wn = 3, tt = "YYYY-MM-DD", zn = "HH:mm", T = 24 * 60, N = (e) => Number(e.slice(0, 2)) * 60 + Number(e.slice(3, 5)), A = (e) => `${String(Math.floor(e / 60)).padStart(2, "0")}:${String(
  e % 60
).padStart(2, "0")}`, nt = (e) => d(
  `2000-01-01T${A(N(e) % T)}`
).format("h:mm A"), jo = A(T), Wo = (e) => typeof e == "string" && /^\d{2}:\d{2}$/.test(e) && Number(e.slice(3, 5)) < 60 && N(e) <= T, Xn = T / P, rt = (e) => Array.from({ length: Xn }, (t, n) => {
  const r = A(
    (n + e) * P
  );
  return { value: r, label: nt(r) };
}), st = rt(0), ot = rt(1), at = (e) => new Set(e.map((t) => t.value)), Zn = at(st), Qn = at(ot), it = (e, t, n) => n && !t.has(n) ? [...e, { value: n, label: nt(n) }].sort(
  (r, s) => r.value.localeCompare(s.value)
) : e, zo = ({
  include: e
} = {}) => it(st, Zn, e), Xo = ({
  after: e,
  include: t
} = {}) => {
  const n = it(ot, Qn, t);
  return e ? n.filter((r) => r.value > e) : n;
}, Ne = (e) => e ? d(e).format(tt) : null, $ = (e) => e ? d(e).format(zn) : null, Ae = (e, t) => {
  const n = N(t), r = d(e).add(Math.floor(n / T), "day").format(tt);
  return d(
    `${r}T${A(n % T)}`
  ).toISOString();
}, le = (e) => {
  const t = Ne(e.ends_at), n = $(e.ends_at);
  if (!t || !n)
    return null;
  const r = Ne(e.starts_at) ?? t;
  return Math.round(
    d(`${t}T12:00`).diff(`${r}T12:00`, "day", !0)
  ) * T + N(n);
}, Jn = (e) => {
  const t = le(e);
  return t !== null && t > 0 ? A(t) : $(e.ends_at);
}, er = (e) => {
  if (!e.starts_at)
    return !1;
  const t = le(e);
  return t !== null && (t <= 0 || t > T);
}, tr = (e, t) => {
  const n = $(t.starts_at), r = le(t), s = r !== null && r > 0 ? A(r) : $(t.ends_at);
  return {
    ...n ? { starts_at: Ae(e, n) } : {},
    ...s ? { ends_at: Ae(e, s) } : {}
  };
}, Me = (e) => {
  const t = d(e), n = t.minute() + t.second() / 60 + t.millisecond() / 6e4, r = Math.round(n / P) * P;
  return t.second(0).millisecond(0).add(r - t.minute(), "minute").toISOString();
}, nr = (e) => {
  const t = e.starts_at ? Me(e.starts_at) : e.starts_at;
  let n = e.ends_at ? Me(e.ends_at) : e.ends_at;
  return t && n && !d(n).isAfter(t) && (n = d(t).add(P, "minute").toISOString()), {
    ..."starts_at" in e ? { starts_at: t } : {},
    ..."ends_at" in e ? { ends_at: n } : {}
  };
}, Zo = (e, t) => tr(e, nr(t)), Qo = ({
  previousStart: e,
  previousEnd: t,
  nextStart: n
}) => {
  if (!t)
    return null;
  if (!e)
    return t > n ? t : null;
  const r = N(t) - N(e);
  if (r <= 0)
    return null;
  const s = N(n) + r;
  return s > T ? null : A(s);
}, Jo = (e) => e.starts_at && e.ends_at ? d(e.ends_at).diff(e.starts_at, "minute") : null, ea = (e) => e !== null && e > Wn * 60, ta = (e, t = d()) => !!e.ends_at && d(e.ends_at).isBefore(t), na = (e) => {
  if (e <= 0)
    return "0m";
  const t = Math.floor(e / 60), n = e % 60;
  return t ? n ? `${t}h ${n}m` : `${t}h` : `${n}m`;
}, rr = (e) => {
  const t = $(e == null ? void 0 : e.starts_at);
  return !e || !t ? null : {
    start_time: t,
    end_time: e.ends_at && !er(e) ? Jn(e) : null
  };
}, ra = ({
  event: e,
  firstDate: t,
  name: n,
  activityIds: r
}) => {
  const s = jn(e, Le), o = s.cms_activity_id;
  return {
    ...s,
    ...o != null && !r.includes(o) && { cms_activity_id: null },
    name: n,
    ...rr(t)
  };
};
function sa(e) {
  switch ((e ?? "").toLowerCase()) {
    case "man":
      return { subject: "he", wants: "wants" };
    case "woman":
      return { subject: "she", wants: "wants" };
    default:
      return { subject: "they", wants: "want" };
  }
}
const sr = 48, oa = (e, t = /* @__PURE__ */ new Date()) => d(e).diff(d(t), "hour", !0) >= sr, aa = Ct.Stripe, I = {
  // Square, at 1000x1000, because the app's event cards are a square frame
  // (EventCardRecipe). It is also the card image in the weekly digest email,
  // whose template lives in SendGrid rather than in this repo.
  [f.EventPrimary]: {
    field: "primary_image",
    label: "Event image",
    slug: "primary",
    width: 1e3,
    height: 1e3,
    helper: "Shown on event cards and in the digest email."
  },
  // The event page renders this full width at 16:9. It is also the share
  // card, which is close enough to that ratio to fill it.
  [f.EventHero]: {
    field: "hero_image",
    label: "Hero image",
    slug: "hero",
    width: 1920,
    height: 1080,
    helper: "Shown across the top of the event page, and as the link preview when the event is shared."
  }
}, or = [
  f.EventPrimary,
  f.EventHero
], ia = (e) => or.includes(e), ca = (e) => e.hero_image || e.primary_image || void 0, la = ({
  sparkId: e,
  role: t,
  filename: n
}) => `events/${e}/${I[t].slug}/${n}`, ct = [
  {
    key: "eyebrow",
    label: "Audience line",
    description: "A short line over the title saying who it is for and where. Usually set small in letter-spaced caps.",
    example: "Atlanta 20s & 30s Singles"
  },
  {
    key: "title",
    label: "Title",
    description: "The event's name, often a pun with an ampersand. 2 to 5 words; allow up to 40 characters.",
    example: "Boots & Meetcutes"
  },
  {
    key: "subtitle",
    label: "Subtitle",
    description: "What the night is, in a few words. May be empty.",
    example: "Singles Country Dancing Night"
  },
  {
    key: "date",
    label: "Date",
    description: "The full date.",
    example: "Wednesday, September 23"
  },
  {
    key: "weekday",
    label: "Weekday",
    description: "The day of the week.",
    example: "Wednesday"
  },
  {
    key: "weekdayShort",
    label: "Weekday (short)",
    description: "The abbreviated day, as posters write it.",
    example: "Weds"
  },
  {
    key: "month",
    label: "Month",
    description: "The month name.",
    example: "September"
  },
  {
    key: "monthShort",
    label: "Month (short)",
    description: "The abbreviated month.",
    example: "Sept"
  },
  {
    key: "day",
    label: "Day",
    description: "The day of the month, as a number.",
    example: "23"
  },
  {
    key: "dayOrdinal",
    label: "Day (ordinal)",
    description: "The day of the month with its suffix.",
    example: "23rd"
  },
  {
    key: "daySuffix",
    label: "Day suffix",
    description: "The day's ordinal suffix alone, to set as a superscript after {{day}}.",
    example: "rd"
  },
  {
    key: "dateNumeric",
    label: "Date (numeric)",
    description: "Month and day as numbers.",
    example: "9/23"
  },
  {
    key: "time",
    label: "Start time",
    description: "When it starts.",
    example: "6:30 PM"
  },
  {
    key: "timeRange",
    label: "Time range",
    description: "Start and end time.",
    example: "6:30–9:30 PM"
  },
  {
    key: "venue",
    label: "Venue",
    description: "The name of the place the event is at.",
    example: "Big Shots Country Bar"
  },
  {
    key: "address",
    label: "Address",
    description: "The street address. May be empty.",
    example: "11000 Alpharetta Hwy"
  },
  {
    key: "city",
    label: "City / neighborhood",
    description: "The city or neighborhood the venue is in.",
    example: "Roswell"
  },
  {
    key: "price",
    label: "Price",
    description: "The ticket price. May be empty.",
    example: "$25"
  },
  {
    key: "ages",
    label: "Ages",
    description: "Who the event is for, by age.",
    example: "Ages 25–49"
  },
  {
    key: "perk",
    label: "Perk",
    description: "One thing that is included, for a sticker or callout. May be empty.",
    example: "Welcome drink included!"
  },
  {
    key: "tagline",
    label: "Tagline",
    description: "A short hook, like RALLY • CONNECT • SPARK. May be empty.",
    example: "Line dance lessons + food & drink specials"
  },
  {
    key: "cta",
    label: "Call to action",
    description: "What the viewer should do next. May be empty.",
    example: "Tickets at greenflagdate.com"
  }
], ua = Object.fromEntries(
  ct.map((e) => [
    e.key,
    e.example
  ])
), da = [
  {
    key: "logo_white",
    description: "The Green Flag logo: a flag in a circle, with GREEN FLAG in condensed caps to its right. White. 190×54 (about 3.5:1). For dark, green or photo backgrounds.",
    path: "/brand/logo_text_right_white.svg"
  },
  {
    key: "logo_green",
    description: "The same logo in brand green (#39B87D). For light backgrounds.",
    path: "/brand/logo_text_right_green.svg"
  },
  {
    key: "mark_white",
    description: "The flag-in-a-circle mark alone, white, square. Works as a bullet or badge.",
    path: "/brand/logo_only_white.svg"
  },
  {
    key: "mark_green",
    description: "The flag-in-a-circle mark alone, brand green, square.",
    path: "/brand/logo_only_green.svg"
  }
], lt = (e) => `https://fonts.googleapis.com/css2?${e.map((t) => `family=${t}`).join("&")}&display=block`, ar = [
  {
    family: "League Gothic",
    spec: "League+Gothic",
    use: "Tall condensed caps. The face of the Green Flag wordmark."
  },
  {
    family: "Poppins",
    spec: "Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,400;1,700",
    use: "Geometric sans, weights 300–900. Clean details and letter-spaced caps lines."
  },
  {
    family: "Anton",
    spec: "Anton",
    use: "Heavy condensed sans for huge stacked titles."
  },
  {
    family: "Bebas Neue",
    spec: "Bebas+Neue",
    use: "Clean condensed caps for details."
  },
  {
    family: "Archivo Black",
    spec: "Archivo+Black",
    use: "Heavy grotesk for chunky titles."
  },
  {
    family: "Shrikhand",
    spec: "Shrikhand",
    use: "Fat 70s retro display, for playful game-night energy."
  },
  {
    family: "Titan One",
    spec: "Titan+One",
    use: "Round, bold, friendly display."
  },
  { family: "Rye", spec: "Rye", use: "Ornate Western / saloon display." },
  {
    family: "Bodoni Moda",
    spec: "Bodoni+Moda:ital,wght@0,400;0,500;0,700;0,900;1,400;1,700",
    use: "High-contrast Didone serif, for editorial and upscale nights."
  },
  {
    family: "Playfair Display",
    spec: "Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700",
    use: "Transitional display serif, roman and italic."
  },
  {
    family: "DM Serif Display",
    spec: "DM+Serif+Display:ital@0;1",
    use: "Warm display serif."
  },
  {
    family: "Pinyon Script",
    spec: "Pinyon+Script",
    use: "Formal calligraphic script, for elegant titles like Happy Hour."
  },
  {
    family: "Great Vibes",
    spec: "Great+Vibes",
    use: "Flowing script, lighter than Pinyon."
  },
  {
    family: "Yellowtail",
    spec: "Yellowtail",
    use: "Retro monoline script; outline it for a neon-sign look."
  },
  {
    family: "Caveat",
    spec: "Caveat:wght@400;700",
    use: "Handwriting, for notes and asides."
  },
  {
    family: "Permanent Marker",
    spec: "Permanent+Marker",
    use: "Marker lettering, for stickers and scribbled callouts."
  },
  {
    family: "IBM Plex Mono",
    spec: "IBM+Plex+Mono:wght@400;500;700",
    use: "Typewriter-like mono, for small tracked lines."
  }
], ir = lt(
  ar.map((e) => e.spec)
), ee = [
  {
    key: "event",
    label: I[f.EventPrimary].label,
    width: I[f.EventPrimary].width,
    height: I[f.EventPrimary].height,
    role: f.EventPrimary
  },
  {
    key: "hero",
    label: I[f.EventHero].label,
    width: I[f.EventHero].width,
    height: I[f.EventHero].height,
    role: f.EventHero
  },
  { key: "ig_post", label: "Instagram post", width: 1080, height: 1440 },
  { key: "ig_story", label: "Instagram story", width: 1080, height: 1920 },
  { key: "meta_feed", label: "Meta feed ad", width: 1080, height: 1350 },
  { key: "meta_link", label: "Meta link ad", width: 1200, height: 628 }
], _a = (e) => ee.find((t) => t.key === e) ?? ee[0];
d.extend(xe);
d.extend(re);
d.extend(se);
const q = (e, t) => e ? d(e).tz(t) : null, L = (e) => e.minute() === 0 ? e.format("h") : e.format("h:mm"), ut = (e) => `${L(e)} ${e.format("A")}`, dt = (e, t) => t ? e.format("A") === t.format("A") ? `${L(e)}–${L(t)} ${t.format("A")}` : `${L(e)} ${e.format("A")}–${L(t)} ${t.format("A")}` : ut(e), ma = (e, t, n) => {
  const r = q(e, n);
  return r ? dt(r, q(t, n)) : "";
}, cr = (e) => {
  if (e == null)
    return "";
  if (Number(e) === 0)
    return "Free";
  const t = Number(e);
  return Number.isInteger(t) ? `$${t}` : `$${t.toFixed(2)}`;
}, lr = ["Sun", "Mon", "Tues", "Weds", "Thurs", "Fri", "Sat"], ur = [
  "Jan",
  "Feb",
  "March",
  "April",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
], dr = (e) => {
  const t = (e ?? "").split(",").map((n) => n.trim()).filter(Boolean).filter((n) => !/^[A-Z]{2}(\s+\d{5}(-\d{4})?)?$/.test(n)).filter((n) => !/^\d{5}(-\d{4})?$/.test(n)).filter((n) => n !== "USA");
  return t.length < 2 ? { street: t[0] ?? "", city: "" } : {
    street: t.slice(0, -1).join(", "),
    city: t[t.length - 1]
  };
}, _r = (e) => {
  const t = (e ?? "").trim(), n = t.indexOf(":"), [r, s] = n > 0 ? [t.slice(0, n), t.slice(n + 1).trim()] : [t, ""];
  return { title: r.replace(/\s+(@|at)\s+.*$/i, "").replace(/\s+[-–—]\s+.*$/, "").trim() || r.trim(), subtitle: s };
}, mr = {
  [b.LgbtqMen]: "Queer Men",
  [b.LgbtqWomen]: "Queer Women",
  [b.LgbtqAll]: "LGBTQ+"
}, fr = (e, t) => {
  const n = t || "Atlanta", r = e.audience ? mr[e.audience] : "", s = e.min_age ? Fe(e.min_age, e.max_age, e.age_range_label).text.replace(" and ", " & ").replace("-", "–") : "";
  return r ? s ? `${n} ${r} · ${s}` : `${n} ${r}` : s ? /\ds\b/.test(s) ? `${n} ${s} Singles` : `${n} Singles ${s}` : `${n} Singles`;
}, hr = (e) => {
  const t = (e ?? "").split(`
`).map((r) => {
    var a;
    const s = r.replace(/[\p{Extended_Pictographic}\u{FE0F}\u{200D}]/gu, "").replace(/^[\s*•\-–]+(?=\S)/, "").trim();
    return (((a = s.match(/^\*\*(.+?)\*\*/)) == null ? void 0 : a[1]) ?? s).replace(/[*_`]/g, "").split(":")[0].replace(/\s*\([^)]*\)/g, "").replace(/[\s.,;!]+$/, "").trim();
  }).filter((r) => r && r.length <= 40), n = t.find((r) => /drink|cocktail|beer|wine|food|bite|snack/i.test(r)) ?? t[0];
  return n ? `${n.charAt(0).toUpperCase()}${n.slice(1)}${/[?]$/.test(n) ? "" : "!"}` : "";
}, gr = "Tickets at greenflagdate.com", fa = (e, t) => {
  const n = q(e.starts_at, t), { title: r, subtitle: s } = _r(e.title), { street: o, city: a } = dr(e.location_address), i = n ? n.format("Do") : "";
  return {
    eyebrow: fr(e, a),
    title: r,
    subtitle: s,
    date: n ? n.format("dddd, MMMM D") : "",
    weekday: n ? n.format("dddd") : "",
    weekdayShort: n ? lr[n.day()] : "",
    month: n ? n.format("MMMM") : "",
    monthShort: n ? ur[n.month()] : "",
    day: n ? n.format("D") : "",
    dayOrdinal: i,
    daySuffix: i.replace(/^\d+/, ""),
    dateNumeric: n ? n.format("M/D") : "",
    time: n ? ut(n) : "",
    timeRange: n ? dt(n, q(e.ends_at, t)) : "",
    venue: e.location ?? "",
    address: o,
    city: a,
    price: cr(e.price),
    ages: e.min_age ? Fe(e.min_age, e.max_age, e.age_range_label).display : "",
    perk: hr(e.whats_included),
    tagline: "",
    cta: gr
  };
}, U = (e) => e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;"), _t = (e) => e.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/'/g, "\\'").replace(/[\r\n]+/g, " ").replace(/</g, "\\3c "), V = (e) => e === "html" ? U : _t, ue = String.raw`\{\{\s*([a-zA-Z]+)(?::([a-zA-Z0-9_-]+))?\s*\}\}`, G = (e, t) => e.values[t] ?? "", we = {
  image: {
    takes: "image",
    showsText: !1,
    fill: (e, t, n) => V(n)(t.images[e] ?? "")
  },
  asset: {
    takes: "asset",
    showsText: !1,
    fill: (e, t, n) => V(n)(t.assets[e] ?? "")
  },
  length: {
    takes: "variable",
    showsText: !1,
    fill: (e, t) => String(G(t, e).length)
  },
  upper: {
    takes: "variable",
    showsText: !0,
    fill: (e, t, n) => V(n)(
      G(t, e).toUpperCase().replace(/(\d)S\b/g, "$1s")
    )
  },
  split: {
    takes: "variable",
    showsText: !0,
    fill: (e, t, n) => {
      const r = G(t, e);
      if (n === "css")
        return _t(r);
      const s = r.indexOf("&");
      if (s < 0)
        return `<span class="gf-before">${U(r)}</span>`;
      const o = r.slice(0, s).trim(), a = r.slice(s + 1).trim();
      return [
        o && `<span class="gf-before">${U(o)}</span>`,
        '<span class="gf-amp">&amp;</span>',
        a && `<span class="gf-after">${U(a)}</span>`
      ].filter(Boolean).join(" ");
    }
  }
}, de = (e) => Object.prototype.hasOwnProperty.call(we, e) ? we[e] : void 0, pr = (e) => [...e.matchAll(new RegExp(ue, "g"))].map(([, t, n]) => ({
  name: t,
  arg: n
})), Re = (e, t, n) => e.replace(
  new RegExp(ue, "g"),
  (r, s, o) => {
    var a;
    return o ? ((a = de(s)) == null ? void 0 : a.fill(o, t, n)) ?? "" : V(n)(G(t, s));
  }
), yr = (e) => e.replace(/<script\b[\s\S]*?<\/script\s*>/gi, "").replace(
  /<\/?(script|iframe|object|embed|link|meta|base|form|input|button|textarea|select|frame|frameset|noscript)\b[^>]*>/gi,
  ""
).replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "").replace(/(href|src|xlink:href)\s*=\s*(["'])\s*javascript:[^"']*\2/gi, ""), br = (e) => e.replace(/@import[^;]*;?/gi, "").replace(/<\/?style[^>]*>/gi, "").replace(/<\//g, "<\\/"), mt = "gf-root", Er = "gf-layout", te = "data-gf-node", Tr = "data-gf-var", kr = `*,*::before,*::after{box-sizing:border-box}
html,body{margin:0;padding:0;width:100%;height:100%;overflow:hidden;background:#ffffff;-webkit-font-smoothing:antialiased;text-rendering:geometricPrecision}
#${mt}{position:relative;width:100vw;height:100vh;overflow:hidden}
img{display:block;max-width:none}`, vr = new RegExp(
  String.raw`<([a-zA-Z][\w-]*)(\s[^<>]*?)?>(\s*)` + ue + String.raw`(\s*)<\/\1>`,
  "g"
), Ir = (e) => {
  const t = e.replace(
    vr,
    (r, s, o = "", a, i, u, c = "") => {
      var p;
      const l = u ? (p = de(i)) != null && p.showsText ? u : null : i;
      if (!l)
        return r;
      const _ = u ? `{{${i}:${u}}}` : `{{${i}}}`;
      return `<${s}${o} ${Tr}="${l}">${a}${_}${c}</${s}>`;
    }
  );
  let n = 0;
  return t.replace(
    /<([a-zA-Z][\w-]*)(?=[\s/>])/g,
    (r, s) => `<${s} ${te}="${n++}"`
  );
}, Sr = (e) => [
  ...Object.entries((e == null ? void 0 : e.transforms) ?? {}).map(
    ([t, n]) => `[${te}="${Number(t)}"]{translate:${n.x * 100}vw ${n.y * 100}vh;scale:${n.scale}${n.inline ? ";display:inline-block" : ""}}`
  ),
  ...((e == null ? void 0 : e.deleted) ?? []).map(
    (t) => `[${te}="${Number(t)}"]{visibility:hidden!important}`
  )
].join(`
`), ft = (e) => Ir(yr(e)), ha = (e, t, n) => {
  var a;
  const r = Re(
    ft(e.html),
    t,
    "html"
  ), s = Re(
    br(e.css),
    t,
    "css"
  );
  return `<!doctype html><html><head><meta charset="utf-8">${[
    ir,
    ...(a = e.fonts) != null && a.length ? [lt(e.fonts)] : []
  ].map(
    (i) => `<link rel="stylesheet" href="${i}" crossorigin="anonymous">`
  ).join("")}<style>${kr}</style><style>${s}</style><style id="${Er}">${Sr(n)}</style></head><body><div id="${mt}">${r}</div></body></html>`;
}, ga = (e) => {
  var n;
  const t = /* @__PURE__ */ new Set();
  for (const r of [e.html, e.css])
    for (const { name: s, arg: o } of pr(r))
      o && ((n = de(s)) == null ? void 0 : n.takes) === "image" && t.add(o);
  return [...t];
}, pa = {
  values: {},
  transforms: {},
  deleted: [],
  deletedAt: {},
  htmlHash: ""
}, ya = {
  builtIn: (e) => `default:${e}`
}, ba = (e) => /^default:[a-z0-9-]{1,56}$/.test(e), Nr = (e) => {
  let t = 5381;
  for (let n = 0; n < e.length; n++)
    t = (t << 5) + t + e.charCodeAt(n) | 0;
  return (t >>> 0).toString(36);
}, Ea = (e) => Object.keys(e.values).length > 0 || Object.values(e.transforms).some((t) => Object.keys(t).length) || e.deleted.length > 0 || Object.values(e.deletedAt).some((t) => t.length), W = (e, t, n) => typeof e == "number" && Number.isFinite(e) ? Math.min(n, Math.max(t, e)) : null, De = (e) => Array.isArray(e) ? [
  ...new Set(
    e.filter(
      (t) => typeof t == "string" && /^\d{1,4}$/.test(t)
    )
  )
].slice(0, 500) : [], Ta = (e) => {
  const t = e && typeof e == "object" ? e : {}, n = new Set(
    ct.map((l) => l.key)
  ), r = new Set(ee.map((l) => l.key)), s = {}, o = t.values ?? {};
  for (const [l, _] of Object.entries(o))
    n.has(l) && typeof _ == "string" && (s[l] = _.slice(0, 200));
  const a = {}, i = t.transforms ?? {};
  for (const [l, _] of Object.entries(i))
    if (!(!r.has(l) || !_ || typeof _ != "object"))
      for (const [p, D] of Object.entries(_)) {
        if (!/^\d{1,4}$/.test(p) || !D || typeof D != "object")
          continue;
        const M = D, me = W(M.x, -2, 2), fe = W(M.y, -2, 2), he = W(M.scale, 0.1, 10);
        me === null || fe === null || he === null || (a[l] ?? (a[l] = {}), a[l][p] = { x: me, y: fe, scale: he, ...M.inline === !0 ? { inline: !0 } : {} });
      }
  const u = {}, c = t.deletedAt ?? {};
  for (const [l, _] of Object.entries(c)) {
    const p = De(_);
    r.has(l) && p.length && (u[l] = p);
  }
  return {
    values: s,
    transforms: a,
    deleted: De(t.deleted),
    deletedAt: u,
    htmlHash: typeof t.htmlHash == "string" ? t.htmlHash.slice(0, 32) : ""
  };
}, ka = (e, t) => {
  const n = Nr(ft(t));
  return e.htmlHash === n ? e : { ...e, transforms: {}, deleted: [], deletedAt: {}, htmlHash: n };
}, va = (e, t) => ({ ...e, ...t.values }), Ia = (e, t) => ({
  transforms: e.transforms[t] ?? {},
  deleted: [.../* @__PURE__ */ new Set([...e.deleted, ...e.deletedAt[t] ?? []])]
}), Sa = (e, t) => Object.keys(e.transforms[t] ?? {}).length > 0 || (e.deletedAt[t] ?? []).some((n) => !e.deleted.includes(n)), Na = (e, t, n) => {
  if (n.trim())
    return { ...e, values: { ...e.values, [t]: n } };
  if (!(t in e.values))
    return e;
  const r = { ...e.values };
  return delete r[t], { ...e, values: r };
}, Ar = (e, t, n) => {
  const r = { ...e.transforms, [t]: n };
  return Object.keys(n).length || delete r[t], { ...e, transforms: r };
}, Aa = (e, t, n, r) => {
  if (r)
    return { ...e, deleted: [.../* @__PURE__ */ new Set([...e.deleted, ...n])] };
  const s = e.deletedAt[t] ?? [];
  return {
    ...e,
    deletedAt: {
      ...e.deletedAt,
      [t]: [.../* @__PURE__ */ new Set([...s, ...n])]
    }
  };
}, Ma = (e, t) => {
  const n = Ar(e, t, {}), r = { ...n.deletedAt };
  return delete r[t], { ...n, deletedAt: r };
}, wa = (e, t) => {
  const n = { ...e.deletedAt };
  return delete n[t], { ...e, deleted: [], deletedAt: n };
}, z = [
  "zero",
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
  "eleven",
  "twelve",
  "thirteen",
  "fourteen",
  "fifteen",
  "sixteen",
  "seventeen",
  "eighteen",
  "nineteen"
], Mr = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety"
], ht = (e) => {
  if (!Number.isFinite(e) || e < 0 || !Number.isInteger(e))
    return null;
  if (e < 20)
    return z[e];
  if (e < 100) {
    const t = Mr[Math.floor(e / 10)], n = e % 10;
    return n ? `${t}-${z[n]}` : t;
  }
  if (e < 1e3) {
    const t = `${z[Math.floor(e / 100)]} hundred`, n = e % 100;
    return n ? `${t} ${ht(n)}` : t;
  }
  return null;
}, wr = (e, t, n) => {
  if (e === void 0 || e === "")
    return `[${(n == null ? void 0 : n.label) ?? "not set"}]`;
  const r = Number(e);
  if (t === "words") {
    const s = Number.isNaN(r) ? null : ht(r);
    return s ? `${s} (${r})` : String(e);
  }
  if ((n == null ? void 0 : n.type) === "currency")
    return Number.isNaN(r) ? String(e) : w(r);
  if ((n == null ? void 0 : n.type) === "date") {
    const s = d(String(e));
    return s.isValid() ? s.format("MMMM D, YYYY") : String(e);
  }
  return String(e);
}, _e = (e) => {
  if (e === void 0)
    return !1;
  if (typeof e == "boolean")
    return e;
  if (typeof e == "number")
    return e !== 0;
  const t = e.trim().toLowerCase();
  return t !== "" && t !== "false";
}, ne = (e, t) => {
  const r = /\{\{#if\s+([a-zA-Z0-9_]+)\}\}/.exec(e);
  if (!r)
    return e;
  const s = r[1], o = r.index, a = o + r[0].length, i = /\{\{#if\s+[a-zA-Z0-9_]+\}\}|\{\{else\}\}|\{\{\/if\}\}/g;
  i.lastIndex = a;
  let u = 0, c = -1, l = -1, _ = i.exec(e);
  for (; _; ) {
    if (_[0].startsWith("{{#if"))
      u += 1;
    else if (_[0] === "{{else}}")
      u === 0 && c === -1 && (c = _.index);
    else {
      if (u === 0) {
        l = _.index;
        break;
      }
      u -= 1;
    }
    _ = i.exec(e);
  }
  if (l === -1)
    return ne(
      `${e.slice(0, o)}${e.slice(a)}`,
      t
    );
  const p = c === -1 ? e.slice(a, l) : e.slice(a, c), D = c === -1 ? "" : e.slice(c + 8, l), M = _e(t[s]) ? p : D;
  return ne(
    `${e.slice(0, o)}${M}${e.slice(l + 7)}`,
    t
  );
}, Rr = (e, t, n) => e.replace(
  /\{\{\s*([a-zA-Z0-9_]+)\s*(?:\|\s*([a-zA-Z]+)\s*)?\}\}/g,
  (r, s, o) => wr(t[s], o, n.get(s))
), X = (e) => {
  const t = [], n = /\*\*([^*]+)\*\*/g;
  let r = 0, s = n.exec(e);
  for (; s; )
    s.index > r && t.push({ text: e.slice(r, s.index), bold: !1 }), t.push({ text: s[1], bold: !0 }), r = s.index + s[0].length, s = n.exec(e);
  return r < e.length && t.push({ text: e.slice(r), bold: !1 }), t.length ? t : [{ text: e, bold: !1 }];
}, Dr = (e) => `Event ${e + 1}`, Oe = { key: "event", label: "Event" }, Or = (e, t) => ({
  type: "schedule",
  columns: [Oe, ...e.scheduleFields ?? []],
  rows: t.map((n, r) => ({
    ...n,
    [Oe.key]: Dr(r)
  }))
}), xr = 24, Lr = (e, t) => !e.scheduleToggleKey || _e(t[e.scheduleToggleKey]), Ra = (e, t, n) => {
  var o;
  if (!((o = e.scheduleFields) != null && o.length) || !Lr(e, t))
    return [];
  const r = e.scheduleCountKey ? Number(t[e.scheduleCountKey]) : n.length, s = Number.isFinite(r) ? Math.trunc(r) : n.length;
  return Array.from(
    { length: Math.min(Math.max(s, 1), xr) },
    (a, i) => n[i] ?? {}
  );
}, Pr = (e) => {
  const t = /* @__PURE__ */ new Map();
  for (const n of e.groups)
    for (const r of n.fields)
      t.set(r.key, r);
  return t;
}, Da = (e) => {
  const t = {};
  for (const n of e.groups)
    for (const r of n.fields)
      r.default !== void 0 ? t[r.key] = r.default : r.type === "boolean" && (t[r.key] = !1);
  return t;
}, $r = (e, t) => !e.dependsOn || _e(t[e.dependsOn]), Oa = (e, t, n) => {
  const r = Pr(e), s = Rr(
    ne(e.body, t),
    t,
    r
  ), o = [];
  for (const a of s.split(`
`)) {
    const i = a.trim();
    if (i) {
      if (i.startsWith("::signatures")) {
        o.push({
          type: "signatures",
          parties: i.slice(12).split("|").map((u) => u.trim()).filter(Boolean)
        });
        continue;
      }
      if (i === "::schedule") {
        o.push(Or(e, n));
        continue;
      }
      if (i.startsWith("## ")) {
        o.push({ type: "heading", runs: X(i.slice(3)) });
        continue;
      }
      if (i.startsWith("# ")) {
        o.push({ type: "title", runs: X(i.slice(2)) });
        continue;
      }
      o.push({ type: "paragraph", runs: X(i) });
    }
  }
  return o;
}, Cr = (e) => e.map((t) => t.text).join(""), xa = (e) => e.map((t) => {
  if (t.type === "signatures")
    return t.parties.map(
      (r) => `${r}

Signature: ______________  Date: __________`
    ).join(`

`);
  if (t.type === "schedule") {
    const r = t.columns.map((o) => o.label).join(" | "), s = t.rows.map(
      (o) => t.columns.map((a) => o[a.key] ?? "").join(" | ")
    );
    return [r, ...s].join(`
`);
  }
  const n = Cr(t.runs);
  return t.type === "title" || t.type === "heading" ? `
${n.toUpperCase()}
` : n;
}).join(`

`), La = (e, t) => {
  const n = [];
  for (const r of e.groups)
    for (const s of r.fields) {
      if (s.type === "boolean" || s.optional || !$r(s, t))
        continue;
      const o = t[s.key];
      (o == null || o === "") && n.push(s);
    }
  return n;
}, Pa = (e) => e.trim().toLowerCase();
export {
  aa as ACTIVE_PAYMENT_PROVIDER,
  Qr as ADMIN_ANALYTICS_MONTHS,
  Wr as ADMIN_EVENT_TEMPLATE_FIELDS,
  $t as ASSIGNABLE_GROUPS,
  Ve as ATLANTA_TAX,
  zr as ATTENDANCE_PATH,
  vt as AddressComponentType,
  ze as CARD_FEE_FIXED_CENTS,
  We as CARD_FEE_PERCENT,
  Te as CARD_FEE_RATE_LABEL,
  Rt as CHECK_IN_PATH,
  kt as ContactPreferenceEnum,
  Yt as CouponType,
  St as CredentialType,
  Pe as CreditCardType,
  un as DEFAULT_EVENT_HOURS,
  ss as DEFAULT_GROUP_PARAMS,
  gr as DEFAULT_MARKETING_CTA,
  v as DatingIntention,
  gs as DayOfWeekOffset,
  bt as DrinkingEnum,
  Tt as DrugsEnum,
  pa as EMPTY_MARKETING_DESIGN_EDITS,
  wt as EVENT_TEMPLATE_FIELDS,
  ua as EXAMPLE_MARKETING_VALUES,
  Uo as GENDER_SPLIT_INPUTS,
  os as GROUPS_CHANGED,
  Pt as GroupType,
  gt as HaveChildrenEnum,
  fs as INTERNAL_SERVER_ERROR,
  Wn as LONG_SPARK_HOURS,
  da as MARKETING_ASSETS,
  ar as MARKETING_FONTS,
  ir as MARKETING_FONTS_STYLESHEET,
  ee as MARKETING_IMAGE_SIZES,
  sn as MARKETING_ITEMS,
  k as MARKETING_ITEM_KEYS,
  Er as MARKETING_LAYOUT_STYLE_ID,
  te as MARKETING_NODE_ATTR,
  mt as MARKETING_ROOT_ID,
  ct as MARKETING_TEMPLATE_VARIABLES,
  we as MARKETING_TOKEN_FUNCTIONS,
  Tr as MARKETING_VAR_ATTR,
  rs as MAX_GROUP_COUNT,
  Ke as MAX_INVOICE_FEE_CENTS,
  Ie as MAX_INVOICE_LINE_CENTS,
  Rn as MAX_INVOICE_LINE_LABEL_LENGTH,
  wn as MAX_INVOICE_LINE_QUANTITY,
  on as MAX_MARKETING_QUANTITY,
  Ms as MAX_MEDIA_BYTES,
  Ho as MAX_PARTNER_BACKUP_DATES,
  Wt as MAX_RELATIVE_OFFSET_DAYS,
  xr as MAX_SCHEDULE_ROWS,
  Et as MarajuanaEnum,
  f as MarketingMediaType,
  Br as MediaKey,
  Ds as NOTIFICATION_CONSENT_DISCLOSURE,
  xs as NOTIFICATION_CONSENT_DISCLOSURE_HASH,
  Os as NOTIFICATION_CONSENT_POLICY_PHRASES,
  ps as NOTIFICATION_CONSENT_SOURCES,
  Ps as NUM_LIKES_BEFORE_UPDATE,
  S as NotificationPreferenceType,
  x as NotificationPreferenceValue,
  Yr as ONE_TIME_MESSAGE_IDS,
  Lt as ORGANIZATION_MEMBER_ROLES,
  es as ORGANIZATION_MEMBER_ROLE_LABELS,
  Vn as PARTNER_SPARK_FIELDS,
  Hn as PARTNER_SUBMIT_REQUIREMENTS,
  ms as PAYMENT_ERROR,
  hs as PAYMENT_PROVIDER_MISMATCH,
  as as PREFERRED_VENUE_PARTNER_SLUG,
  $o as PUBLISHED_SPARK_STATUSES,
  _s as PaymentErrorCategory,
  Ct as PaymentProvider,
  Nt as ProfilePictureKey,
  jt as RELATIVE_TIME_ANCHORS,
  xt as RESERVED_ORGANIZATION_SLUGS,
  tt as SPARK_DATE_FORMAT,
  T as SPARK_DAY_MINUTES,
  jo as SPARK_END_OF_DAY,
  As as SPARK_FEEDBACK_DEADLINE_DAYS,
  or as SPARK_IMAGE_ROLES,
  I as SPARK_IMAGE_SPECS,
  Fn as SPARK_PUBLISH_REQUIREMENTS,
  sr as SPARK_REFUND_CUTOFF_HOURS,
  P as SPARK_TIME_SLOT_MINUTES,
  yt as SmokingEnum,
  b as SparkAudience,
  Y as SparkEventKind,
  Mt as SparkGenderType,
  At as SparkParticipantStatus,
  R as SparkStatus,
  K as SparkSubmissionStatus,
  Le as TEMPLATE_EVENT_FIELDS,
  Gt as TEXT_ELIGIBLE_NOTIFICATION_CATEGORIES,
  Kt as UTM_KEYS,
  Ut as UnmatchReason,
  Ft as UserRelationshipType,
  Ls as VALUE_MAX_LENGTH,
  y as ValueCategory,
  Vt as WaitlistType,
  pt as WantChildrenEnum,
  Mo as activeSparkDiscount,
  Lo as activityEmoji,
  xo as activityName,
  B as addInvoiceMonths,
  us as adminUserDisplayName,
  xa as agreementToText,
  Ir as annotateMarketingHtml,
  ls as applyRefundAll,
  ds as asCreditCardType,
  J as asksGenderBalance,
  Cr as blockText,
  Ra as buildSchedule,
  en as calculateSparkReceipt,
  Us as calculateSparkRegisterFormFilledFields,
  Vs as calculateSparkRegisterFormMissingFields,
  qe as calculateTax,
  qn as capacitySuitsSplit,
  gn as cardFeeCents,
  Gs as centsAsDollarsInput,
  Zr as checkInTokenFromScan,
  Pr as collectFields,
  Ae as combineSparkDateAndTime,
  Kr as commonGenders,
  Hr as commonReligions,
  Eo as computePartnerInvoice,
  js as couponCodeIsRedeemable,
  Ye as couponDiscount,
  Bs as couponDiscountLabel,
  Ws as couponTermsOf,
  Ys as csvSafeText,
  ae as datingIntentionMeta,
  Cs as decodeUtmValue,
  Da as defaultValues,
  Ks as describeRelativeTime,
  qs as dollarsInputAsCents,
  Ce as emailEnabledForCategory,
  $s as encodeUtmValue,
  Qo as endTimeForMovedStart,
  Ue as etZone,
  Fs as extractUtmParams,
  Re as fillMarketingTemplate,
  E as formatCents,
  w as formatCurrency,
  cr as formatMarketingPrice,
  ma as formatMarketingTime,
  na as formatSparkDuration,
  Zs as formatSparkReceiptLines,
  Vo as genderCapacitiesFor,
  sa as genderPronoun,
  et as genderSplitFor,
  Fe as getAgeRangeString,
  Ns as getDateRangeString,
  Is as getDateTimeRangeString,
  Ss as getDateTimeStartString,
  wo as getDatingIntentionLabel,
  Do as getDatingIntentionValueCategoryDescription,
  Ro as getDatingIntentionValueCategoryName,
  vs as getMondayForSpark,
  lt as googleFontsStylesheet,
  io as hasMarketing,
  Ea as hasMarketingDesignEdits,
  co as hasMarketingDone,
  Sa as hasMarketingSizeLayout,
  cs as hasRole,
  Nr as hashMarketingHtml,
  An as invoiceEventEndsAt,
  Mn as invoiceFinalization,
  fn as invoiceMonthEnd,
  po as invoiceMonthLabel,
  _n as invoiceMonthOf,
  mn as invoiceMonthStart,
  yo as invoiceMonthsBetween,
  Js as invoiceTermsOf,
  Cn as isAgeWithinSparkWindow,
  is as isAssignableGroup,
  Xr as isAttendanceAnswer,
  pe as isCheckInToken,
  $r as isFieldActive,
  jr as isGreenFlagTemplate,
  go as isInvoiceMonth,
  ba as isMarketingDesignKey,
  ie as isMarketingItemKey,
  He as isMarketingQuantity,
  an as isMarketingRateCents,
  ts as isOrganizationMemberRole,
  Jr as isReservedOrganizationSlug,
  oa as isSparkCancellationRefundable,
  Oo as isSparkEligibleForUser,
  Pn as isSparkFull,
  $n as isSparkFullFor,
  ia as isSparkImageRole,
  Wo as isSparkTimeValue,
  Ot as isUuidToken,
  To as lateRefundMonth,
  uo as logAddsMarketing,
  ns as mapGroupMembers,
  fo as marketingAskedCents,
  ya as marketingDesignKey,
  Ia as marketingDesignLayoutAt,
  va as marketingDesignValues,
  ho as marketingDoneCents,
  _a as marketingImageSize,
  cn as marketingIsOffered,
  H as marketingItem,
  Sr as marketingLayoutCss,
  mo as marketingLines,
  ft as marketingNodeMarkup,
  so as marketingPackageFor,
  ce as marketingRateCents,
  ga as marketingTemplateImageSlots,
  pr as marketingTemplateTokens,
  fa as marketingTemplateValuesFromSpark,
  de as marketingTokenFunction,
  qr as mergeProfile,
  Bo as missingPartnerSubmitRequirements,
  Po as missingSparkPublishRequirements,
  Pa as normalizeEmail,
  ws as notificationCategories,
  ks as notificationEnabledForCategory,
  Rs as notificationPreferenceValues,
  ht as numberToWords,
  Xt as parseCouponDiscount,
  Qt as parseCouponTermsWithoutWindow,
  Dn as parseInvoiceLinePricing,
  vo as parseInvoiceLineUpdate,
  Qs as parseInvoiceTerms,
  no as parseMarketingItems,
  ro as parseMarketingLog,
  to as parseMarketingRates,
  Q as parseRelativeTime,
  X as parseRuns,
  Io as parseSparkDiscount,
  Xs as parseTemplateCoupons,
  On as parseTemplateDiscount,
  bo as partnerInvoiceLineId,
  Xe as partnerInvoiceNumber,
  ko as partnerInvoiceOutcome,
  Yo as partnerSparkAwaitsReview,
  qo as partnerSparkIsEditable,
  Ko as partnerSparkWasSubmitted,
  Bn as partnerSubmitChecklist,
  jn as pickFields,
  nn as pickInvoiceTerms,
  Co as pickPartnerSparkFields,
  It as profileReplacer,
  ge as profileReviver,
  Yn as proposedDateIsOpen,
  Go as recommendedHostCount,
  ka as reconcileMarketingDesignEdits,
  Oa as renderAgreement,
  ha as renderMarketingTemplate,
  je as requestRateCents,
  ln as requestedMarketing,
  lo as requestsAddMarketing,
  zs as resolveCouponWindow,
  Z as resolveRelativeTime,
  So as resolveSparkDiscount,
  eo as sameInvoiceTerms,
  _o as sameMarketingRequests,
  Hs as sameRelativeTime,
  br as sanitizeMarketingCss,
  Ta as sanitizeMarketingDesignEdits,
  yr as sanitizeMarketingHtml,
  Dr as scheduleRowLabel,
  Fo as soleCmsChoices,
  Ne as sparkDatePart,
  xn as sparkDiscountFromTemplate,
  Jo as sparkDurationMinutes,
  Xo as sparkEndTimeOptions,
  Jn as sparkEndTimePart,
  er as sparkEndsOffTheDay,
  ta as sparkHasEnded,
  la as sparkImageKey,
  ea as sparkIsUnusuallyLong,
  A as sparkMinutesToTime,
  tr as sparkMovedToDay,
  Zo as sparkMovedToDayOnTimeSlots,
  Ln as sparkRegisteredTotal,
  nr as sparkRoundedToTimeSlots,
  ca as sparkShareImage,
  zo as sparkStartTimeOptions,
  Un as sparkStatusIsPublished,
  nt as sparkTimeLabel,
  $ as sparkTimePart,
  dr as splitAddress,
  _r as splitEventTitle,
  Ao as templateDiscountForEvent,
  No as templateDiscountOf,
  ra as templateInputFromEvent,
  Ts as textEnabledForAnyCategory,
  oe as textEnabledForCategory,
  qt as textNotificationSupportedForCategory,
  La as unfilledFields,
  Ge as valueCategoryMeta,
  ys as withEmailEnabled,
  Aa as withMarketingDeleted,
  Na as withMarketingDesignValue,
  ao as withMarketingLog,
  oo as withMarketingRequests,
  Ar as withMarketingTransforms,
  Es as withTextDisabledForAllCategories,
  $e as withTextEnabled,
  bs as withTextEnabledForAllCategories,
  wa as withoutMarketingDeleted,
  Ma as withoutMarketingSizeLayout
};
